import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  Button,
  IconButton,
  Tooltip,
  Stack,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { nanoid } from "@reduxjs/toolkit";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import EditIcon from "@mui/icons-material/Edit";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import store from "../..";
import BalanceIcon from "@mui/icons-material/Balance";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import { useNavigate } from "react-router-dom";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import AssignmentReturnOutlinedIcon from "@mui/icons-material/AssignmentReturnOutlined";
import NotStartedOutlinedIcon from "@mui/icons-material/NotStartedOutlined";
import { toast } from "react-hot-toast";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { redirect } from "react-router-dom";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from "@mui/icons-material/Email";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import {
  paySlipGet,
  SprintInvoicegenerate,
  SprintInvoiceGet,
  StockProcessApi,
  TimetableProcessController,
} from "./Formapireducer";
import OpenInBrowserOutlinedIcon from "@mui/icons-material/OpenInBrowserOutlined";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import FollowTheSignsOutlinedIcon from "@mui/icons-material/FollowTheSignsOutlined";
import LockResetIcon from "@mui/icons-material/LockReset";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PersonPinOutlinedIcon from "@mui/icons-material/PersonPinOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MoreTimeOutlinedIcon from "@mui/icons-material/MoreTimeOutlined";
import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import ExplicitIcon from "@mui/icons-material/Explicit";
import AttributionIcon from "@mui/icons-material/Attribution";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import GroupsIcon from "@mui/icons-material/Groups";
import FlagIcon from "@mui/icons-material/Flag";
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import StreamIcon from "@mui/icons-material/Stream";
import TaskIcon from "@mui/icons-material/Task";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DoneIcon from "@mui/icons-material/Done";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import HdrWeakIcon from "@mui/icons-material/HdrWeak";
import UpdateIcon from "@mui/icons-material/Update";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import {
  Visibility,
  Delete,
  Download,
  PsychologyAlt,
  Psychology,
} from "@mui/icons-material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DashboardIcon from "@mui/icons-material/Dashboard";
import QuizIcon from "@mui/icons-material/Quiz";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Swal from "sweetalert2";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import SprintInvoiceDocument from "../../apps/reports/SprintTaskInvoice";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import EventNoteIcon from "@mui/icons-material/EventNote";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import { getConfig } from "../../config";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import ReceiptPDF2 from "../../apps/reports/Paymentreceipt2";
import PayslipPdf from "../../apps/SkillGlow/Pdf/PayslipPdf";
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
const today = new Date();
const formattedDate = today.toISOString().split("T")[0];
const EMPID = sessionStorage.getItem("EmpId");
const CompId = sessionStorage.getItem("companyId");
console.log("🚀 ~ CompId:", CompId);
const MangerEmpID = JSON.parse(sessionStorage.getItem("MangerEmpID")) || [];
console.log(MangerEmpID, "MangerEmpID");
const FirstLevelSub = JSON.parse(sessionStorage.getItem("FirstLevelSub")) || [];
const currentMonthNumber = new Date().getMonth() + 1;
const currentYear = new Date().getFullYear();
const format = (d) => {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const oneMonthBefore = new Date();
oneMonthBefore.setMonth(today.getMonth() - 1);
const defaultFromDate = format(oneMonthBefore);
const defaultToDate = format(today);
const initialState = {
  rowData: [],
  currentRequestId: null,
  columnData: [],
  loading: false,
  error: "",
  mailOpen: false,
  mailData: {},
  mailGetData: {},
  materialRecID: "",
  isLookupOpen: false,
  isReasonOpen: false,
  ReasonData: {},
  RegGetData: {},
  fromDate: sessionStorage.getItem("FromDate") || formattedDate, // default to formattedDate
  toDate: sessionStorage.getItem("ToDate") || formattedDate,
  EmployeeID: sessionStorage.getItem("EmployeeID") || "",
};

const progressData = {
  DE: 50,
  NO: 30,
  SW: 20,
};

export const mailNotify = createAsyncThunk("email/mailNotify", async (data) => {
  var url = store.getState().globalurl.mailNotificationUrl;

  console.log("get" + JSON.stringify(data));
  console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
  const response = await axios.post(url, data, {
    headers: {
      Authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
    },
  });
  console.log(
    "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
    response,
  );
  return response.data;
});

export const getMail = createAsyncThunk("mail/get", async (data) => {
  var url = store.getState().globalurl.mailContentGeturl;

  console.log("get" + JSON.stringify(data));

  console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
  const response = await axios.post(url, data, {
    headers: {
      Authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
    },
  });
  console.log(
    "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
    response,
  );
  return response.data;
});

export const sendMail = createAsyncThunk(
  "mail/send",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.mailSendUrl;
    const data = {
      ToID: idata.ToID,
      Cc: idata.Cc,
      Subject: idata.Subject,
      Attachment: idata.Attachment,
      Message: idata.Message,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    toast.success("Mail Send Successfully");
    return response.data;
  },
);

export const getApiSlice = createSlice({
  name: "listviewApi",
  initialState,
  reducers: {
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setEmployeeID: (state, action) => {
      state.EmployeeID = action.payload;
    },
    isReasonOpen(state, action) {
      state.isReasonOpen = !state.isReasonOpen;
      state.ReasonData = action.payload;
    },
    productionlookupOpen(state, action) {
      state.isLookupOpen = !state.isLookupOpen;
      //here change
      state.materialRecID = action.payload.materialRecID;
    },
    mailOpen(state, action) {
      state.mailOpen = !state.mailOpen;
      state.mailData = action.payload;
    },
    //  pending(state) {
    //       return {
    //         ...state,
    //         loading: true,
    //         error: false,
    //         rowData: [],
    //         columnData: [],
    //       };
    //     },
    //     errored(state, action) {
    //       return {
    //         ...state,
    //         loading: false,
    //         error: action.payload,
    //       };
    //     },
    //     Success(state, action) {
    //       return {
    //         ...state,
    //         loading: false,
    //         error: "",
    //         rowData: action.payload.rowdata,
    //         columnData: action.payload.columndata,
    //       };
    //     },

    //for_Listview_Rows_Changes

    pending(state, action) {
      state.loading = true;
      state.error = false;
      state.rowData = [];
      state.columnData = [];
      state.currentRequestId = action.payload.requestId;
    },

    Success(state, action) {
      if (state.currentRequestId !== action.payload.requestId) return;

      state.loading = false;
      state.error = "";
      state.rowData = action.payload.rowdata;
      state.columnData = action.payload.columndata;
    },

    errored(state, action) {
      if (state.currentRequestId !== action.payload.requestId) return;

      state.loading = false;
      state.error = action.payload.error;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getMail.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getMail.fulfilled, (state, action) => {
        state.loading = false;

        state.mailGetData = action.payload;
      })
      .addCase(getMail.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// Destructure and export the plain action creators
export const {
  pending,
  errored,
  mailOpen,
  Success,
  productionlookupOpen,
  isReasonOpen,
} = getApiSlice.actions;
export const { setFromDate, setToDate, setEmployeeID } = getApiSlice.actions;
export default getApiSlice.reducer;

// const loader = async () => {

//     return redirect("/");

// };

const productionCardUPdate = (type, recID) => (dispatch, getState) => {
  //  alert(type);

  var updateName = "";

  if (type === "S") {
    updateName = "Production Card Started ";
  }
  if (type === "P") {
    updateName = "Production Card Paused";
  }
  if (type === "C") {
    updateName = "Production Card Completed";
  }
  if (type === "R") {
    updateName = "Production Card Continued";
  }
  var url = store.getState().globalurl.pcdurl;
  var data = {
    accessid: "TR047",
    Type: type,
    RecordID: recID,
  };
  console.log("🚀 ~ file: Listviewapireducer.js:113 ~ data:", data);

  axios
    .post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })

    .then((response) => {
      console.log(
        "🚀 ~ file: Listviewapireducer.js:96 ~ .then ~ response",
        response.data,
      );
      // console.log("response data" + response.data);
      if (response.data.Status == "Y") {
        toast.success(`${updateName}`);
        // window.location.href = '/Apps/TR056/Customer%20Order'
      } else {
        toast.error(`${"Error"}`);
      }
    })
    .catch((error) => {
      dispatch(errored);
      //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
    });
};

const fnProcess = (recID, accessid) => (dispatch, getState) => {
  var url = store.getState().globalurl.imageNameUpdateUrl;

  var data = { accessid: accessid, Recordid: recID };
  console.log(
    "🚀 ~ file: Listviewapireducer.js:228 ~ fnProcess ~ data:",
    JSON.stringify(data),
  );

  axios
    .post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })

    .then((response) => {
      console.log(
        "🚀 ~ file: Listviewapireducer.js:96 ~ .then ~ response",
        response.data,
      );
      // console.log("response data" + response.data);
      if (response.data.Status == "Y") {
        // window.location.href = '/Apps/TR056/Customer%20Order'
      } else {
        toast.error(`${"Error"}`);
      }
    });
};

const indentOrderSave =
  (type, recID, SupplierID, parentID) => (dispatch, getState) => {
    var url = store.getState().globalurl.indentUrl;
    var data = {
      accessid: "TR056",
      Type: type,
      RecordID: recID,
      SupplierID,
    };

    console.log("INDENTSTRUCT" + JSON.stringify(data));
    // dispatch(pending());
    axios
      .post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log(
          "🚀 ~ file: Listviewapireducer.js:96 ~ .then ~ response",
          response.data,
        );
        // alert( JSON.stringify( response.data))
        console.log("response data" + response.data);
        console.log("response data" + response.data.Type);

        if (response.data.Status == "Y") {
          if (response.data.Insert == "Y") {
            toast.success(response.data.Msg);
            if (response.data.Type == "L") {
              window.location.href = `/Apps/Secondarylistview/TR056/Indent Order/${parentID}/${recID}/${response.data.ProdcrdNO}/${response.data.Type}/EditIndent%20Order/${response.data.RecordID}/E`;
            } else {
              window.location.href = `/Apps/Secondarylistview/TR056/Indent Order/${parentID}/${recID}/${response.data.ProdcrdNO}/${response.data.Type}/EditMaterial IndentOrder/${response.data.RecordID}/E`;
            }
          } else {
            if (response.data.Type == "L") {
              window.location.href = `/Apps/Secondarylistview/TR056/Indent Order/${parentID}/${recID}/${response.data.ProdcrdNO}/${response.data.Type}/EditIndent%20Order/${response.data.RecordID}/E`;
            } else {
              window.location.href = `/Apps/Secondarylistview/TR056/Indent Order/${parentID}/${recID}/${response.data.ProdcrdNO}/${response.data.Type}/EditMaterial IndentOrder/${response.data.RecordID}/E`;
            }
          }
        } else {
          toast.error(response.data.Msg);
        }
      });
  };

  const PayslipBtn = ({ CompanyID, EmployeeID, Finyear, Month }) => {
    const dispatch = store.dispatch;
     const config = getConfig();
    const baseurl1 = config.UAAM_URL;
    const [payloading, setPayLoading] = React.useState(false);
 const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const CompanySignature = sessionStorage.getItem("CompanySignature");
  const [footerHeight, setFooterHeight] = useState(60);
    const handlePayPDFGET = async () => {
      try {
        setPayLoading(true);
        const payslip = {
          Month: Month,
          Finyear: Finyear,
          EmployeeID: EmployeeID,
          CompanyID: CompanyID,
        };

        const resultAction = await dispatch(paySlipGet(payslip));

        const data = resultAction.payload.data; // <-- this depends on how your thunk is defined
        console.log(data, "--payslipget data");
        
        if (!data) {
          alert("No data available for PDF");
          return;
        }
        if (!resultAction.payload) {
          console.error("No payload returned");
          return;
        }
        // Generate and download PDF
        const blob = await pdf(
          <PayslipPdf
            data={data}
            filters={{
              Imageurl: baseurl1,
              HeaderImg: HeaderImg,
              FooterImg: FooterImg,
              CompanySignature: CompanySignature,
              footerHeight: footerHeight
            }}
          />,
        ).toBlob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "Payslip.pdf";
        document.body.appendChild(link); // ✅ Important
        link.click();
        document.body.removeChild(link); // ✅ Cleanup
        URL.revokeObjectURL(blobUrl); // ✅ Cleanup
      } catch (err) {
        console.error("PDF generation failed", err);
      } finally {
        setPayLoading(false);
      }
    };

    return (
      <Tooltip title="Download Payslip PDF">
        <IconButton color="info" size="small" onClick={handlePayPDFGET}>
          {payloading ? (
            <CircularProgress size={20} />
          ) : (
            <PictureAsPdfIcon color="error" />
          )}
        </IconButton>
      </Tooltip>
    );
  };


const PurchaseIndent = createAsyncThunk(
  "Production Card/Indent",
  ({ RecordID }) => {
    var url = store.getState().globalurl.pIndentUrl;
    var data = {
      accessid: "TR108",
      RecordID: RecordID,
    };

    console.log("INDENTSTRUCT" + JSON.stringify(data));
    // dispatch(pending());
    axios
      .post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log(
          "🚀 ~ file: Listviewapireducer.js:96 ~ .then ~ response",
          response.data,
        );
        // console.log("response data" + response.data);
        if (response.data.Status == "Y") {
          if (response.data.Insert == "Y") {
            toast.success(response.data.Msg);
            window.location.href = `/Apps/Secondarylistview/TR108/Material IndentOrder/${RecordID}/${response.data.ProdcrdNO}`;
          } else {
            window.location.href = `/Apps/Secondarylistview/TR108/Material IndentOrder/${RecordID}/${response.data.ProdcrdNO}`;
          }
        } else {
          toast.error(response.data.Msg);
        }
      });
  },
);

const CustomerOrderSave = (type, recID) => (dispatch, getState) => {
  //  alert(type);

  var url = store.getState().globalurl.pcdurl;
  var data = {
    accessid: "TR047",
    Type: type,
    RecordID: recID,
  };

  console.log(data);
  // dispatch(pending());
  axios
    .post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })

    .then((response) => {
      console.log(
        "🚀 ~ file: Listviewapireducer.js:96 ~ .then ~ response",
        response.data,
      );
      // console.log("response data" + response.data);
      if (response.data.Status == "Y") {
        toast.success(``);
        // window.location.href = '/Apps/TR056/Customer%20Order'
      } else {
        toast.error(``);
      }
    })
    .catch((error) => {
      dispatch(errored);
      //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
    });
};

export const fetchListview =
  (AccessID, screenName, filter, any, CompId, VerticalLicense) =>
  async (dispatch, getState) => {
    // const navigate = useNavigate();;
    var url = store.getState().globalurl.listViewurl;

    // var CompId = sessionStorage.getItem("compID");
    // alert(filter);

    // const location = useLocation();
    // const state = location.state || {};
    // console.log(state, "--state in fetchListview");

    const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
    const is003Subscription = SubscriptionCode.endsWith("003");
    const is002Subscription = SubscriptionCode.endsWith("002");
    const CompanySignature = sessionStorage.getItem("CompanySignature");
    console.log(CompanySignature, "CompanySignature");
    const sliceSubscriptionCode = SubscriptionCode.slice(-3);
    console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");
    console.log(sliceSubscriptionCode, "----------------sliceSubscriptionCode");
    const HeaderImg = sessionStorage.getItem("CompanyHeader");
    const FooterImg = sessionStorage.getItem("CompanyFooter");
    const config = getConfig();
    const baseurl1 = config.UAAM_URL;
    const year = sessionStorage.getItem("year");
    const CompId = sessionStorage.getItem("companyId");
    const EMPID = sessionStorage.getItem("EmpId");
    console.log(EMPID, "--need to check EMPID");
    const isManager = sessionStorage.getItem("isManager");
    const isScrumaster = sessionStorage.getItem("isScrumaster");
    const isprojectmanager = sessionStorage.getItem("isprojectmanager");
    const ManagerEmpIDCS = sessionStorage.getItem("ManagerEmpIDCS");
    const EMP_TRAINBY = sessionStorage.getItem("EMP_TRAINBY");
    const CompanyQRCode = sessionStorage.getItem("CompanyQRCode");
    console.log("🚀 ~ fetchListview ~ CompanyQRCode:", CompanyQRCode)

    console.log(isManager, "--need to check isManager");

    console.log(isScrumaster, "--need to check isScrumaster");
    console.log(isprojectmanager, "--need to check isprojectmanager");

    // const formatToDMY = (dateStr) => {
    //   if (!dateStr) return "";

    //   const date = new Date(dateStr);

    //   const day = String(date.getDate()).padStart(2, "0");
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const year = date.getFullYear();

    //   return `${day}-${month}-${year}`;
    // };
    const formatToDMY = (dateStr) => {
      if (!dateStr) return "";

      const parts = dateStr.split("-");
      if (parts.length !== 3) return dateStr;

      const [year, month, day] = parts; // if input is yyyy-mm-dd

      return `${day}-${month}-${year}`;
    };

    var LoggedInUserName = sessionStorage.getItem("UserName");
    // alert("LoggedInUserName",LoggedInUserName);
    if (filter != "" && AccessID !== "TR115" && AccessID !== "TR118") {
      if (
        AccessID == "TR011" ||
        AccessID == "TR008" ||
        AccessID == "TR054" ||
        AccessID == "TR052" ||
        AccessID == "TR060" ||
        AccessID == "TR003" ||
        AccessID == "TR021" ||
        AccessID == "TR073" ||
        AccessID == "TR050" ||
        AccessID == "TR074" ||
        AccessID == "TR077" ||
        AccessID == "TR079" ||
        AccessID == "TR080" ||
        AccessID == "TR032" ||
        AccessID == "TR087"
      ) {
        if (AccessID == "TR080") {
          filter =
            "parentID='" +
            filter +
            "'" +
            " " +
            "AND" +
            " " +
            "Finyear='" +
            year +
            "'";
        }
        if (AccessID != "TR080") {
          filter = "parentID='" + filter + "'";
          // console.log("---3---",filter);
        }
      }
      if (
        AccessID != "TR051" &&
        AccessID != "TR032" &&
        AccessID != "TR004" &&
        AccessID != "TR011" &&
        AccessID != "TR157" &&
        AccessID != "TR159" &&
        AccessID != "TR008" &&
        AccessID != "TR054" &&
        AccessID != "TR052" &&
        AccessID != "TR060" &&
        AccessID != "TR003" &&
        AccessID != "TR021" &&
        AccessID != "TR073" &&
        AccessID != "TR050" &&
        AccessID != "TR074" &&
        AccessID != "TR077" &&
        AccessID != "TR079" &&
        AccessID != "TR080" &&
        AccessID != "TR063" &&
        AccessID != "TR047" &&
        AccessID != "TR097" &&
        AccessID != "TR102" &&
        AccessID != "TR103" &&
        AccessID != "TR105" &&
        AccessID != "TR002" &&
        AccessID != "TR087" &&
        AccessID != "TR123" &&
        AccessID != "TR392" &&
        AccessID != "TR394" &&
        AccessID != "TR124" &&
        AccessID != "TR255" &&
        AccessID != "TR254" &&
        AccessID != "TR267" &&
        AccessID != "TR272" &&
        AccessID != "TR256" &&
        AccessID != "TR086" &&
        AccessID != "TR233" &&
       AccessID != "TR391" &&
        AccessID != "TR332" &&
        AccessID != "TR236" &&
        AccessID != "TR246" &&
        AccessID != "TR247" &&
        AccessID != "TR234" &&
        AccessID != "TR235" &&
        AccessID != "TR262" &&
        AccessID != "TR270" &&
        AccessID != "TR354" &&
        AccessID != "TR132" &&
        AccessID != "TR264" &&
        AccessID != "TR331" &&
        AccessID != "TR366" &&
        AccessID != "TR293" &&
        AccessID != "TR248" &&
        AccessID != "TR263" &&
        AccessID != "TR353" &&
        AccessID != "TR284" &&
        AccessID != "TR290" &&
        // AccessID != "TR342" &&
        AccessID != "TR352" &&
        AccessID != "TR307" &&
        AccessID != "TR289" &&
        AccessID !== "TR277" &&
        AccessID !== "TR368"
      ) {
        filter = "parentID=" + `'${filter}'`;
        // console.log("---4---",filter);
      }
      // if (AccessID == "TR134") {
      //   filter = `parentID='${params.parentID}'`; // Assign params.row.RecordID to filter
      // }
      if (AccessID === "TR262") {
        filter = "ProjectID=" + `'${filter}'`;
      }
      if (AccessID === "TR270") {
        filter = "ProjectID=" + `'${filter}'`;
      }

      if (
        AccessID == "TR051" ||
        AccessID == "TR157" ||
        AccessID == "TR159" ||
        AccessID == "TR047" ||
        AccessID == "TR097" ||
        AccessID == "TR063" ||
        AccessID == "TR004" ||
        AccessID == "TR103" ||
        AccessID == "TR102" ||
        AccessID == "TR105" ||
        AccessID == "TR002" ||
        AccessID == "TR123" ||
        AccessID == "TR124" ||
        AccessID == "TR248" ||
        AccessID == "TR086" ||
        AccessID == "TR284" ||
        AccessID == "TR290" ||
        // AccessID == "TR342" ||
        AccessID == "TR352" ||
        AccessID == "TR307" ||
        AccessID == "TR289" ||
        AccessID == "TR366" ||
        AccessID == "TR391" ||
        AccessID == "TR331"
      ) {
        filter = filter;
      }
      // else{
      //   filter = "";
      // }
    }
    if (AccessID == "TR123") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}' `;
    }
     if (AccessID == "TR391") {
    filter = `CompanyID='${CompId}' AND (FromID = ${EMPID} OR ToID = ${EMPID})`;
  }
     if (AccessID == "TR218") {
      filter = `CompanyID ='${CompId}'`;
    }
     if (AccessID == "TR392") {
      filter = `EmployeeID='${EMPID}'`;
    }
    if(AccessID == "TR394"){
      filter = `ManagerID='${EMPID}'`;
    }

    // if (AccessID == "TR331") {
    //   const teamList = Array.isArray(MangerEmpID)
    //     ? MangerEmpID
    //     : [];

    //   const defaultFilter = `EmployeeID IN (${teamList.map(v => `${v}`).join(",")}, '${EMPID}') AND Date BETWEEN '${defaultFromDate}' AND '${defaultToDate}' AND BillableMonth ='${currentMonthNumber}' AND BillableYear='${currentYear}'`;

    //   if (!filter || filter.trim() === "") {
    //     filter = defaultFilter;   // Only use default if no filter passed
    //   } else {
    //     filter = `${filter}`;
    //   }
    // }
    // if (AccessID == "TR331") {

    //   const MangerEmpID =
    //     JSON.parse(sessionStorage.getItem("MangerEmpID")) || [];

    //   if (!MangerEmpID.length) {
    //     console.log("Manager list not ready yet");
    //     return;   // STOP execution until ready
    //   }

    //   const teamList = MangerEmpID;

    //   const defaultFilter =
    //     `EmployeeID IN (${teamList.join(",")}, '${EMPID}') AND Date BETWEEN '${defaultFromDate}' AND '${defaultToDate}' AND BillableMonth ='${currentMonthNumber}'AND BillableYear='${currentYear}' AND CompanyID ='${CompId}'`;

    //   if (!filter || filter.trim() === "") {
    //     filter = defaultFilter;
    //   }
    // }
    if (AccessID == "TR331") {
      const savedFilters =
        JSON.parse(sessionStorage.getItem("TR331_Filters")) || null;

      if (savedFilters) {
        const conditions = [];

        // 🔹 FORMAT DATE HERE
        if (savedFilters.fromDate && savedFilters.toDate) {
          const fromDate = formatToDMY(savedFilters.fromDate);
          const toDate = formatToDMY(savedFilters.toDate);

          conditions.push(`Date BETWEEN '${fromDate}' AND '${toDate}'`);
        }

        if (savedFilters.attmonth) {
          conditions.push(`BillableMonth='${savedFilters.attmonth}'`);
        }

        if (savedFilters.attyear) {
          conditions.push(`BillableYear='${savedFilters.attyear}'`);
        }

        if (savedFilters.Employee?.length > 0) {
          const EmpIds = savedFilters.Employee.map(
            (e) => `'${e.RecordID}'`,
          ).join(",");
          conditions.push(`EmployeeID IN (${EmpIds})`);
        }

        if (savedFilters.project?.length > 0) {
          const projIds = savedFilters.project
            .map((p) => `'${p.RecordID}'`)
            .join(",");
          conditions.push(`ProjectID IN (${projIds})`);
        }

        conditions.push(`CompanyID ='${CompId}'`);

        filter = conditions.join(" AND ");
      } else {
        const MangerEmpID =
          JSON.parse(sessionStorage.getItem("MangerEmpID")) || [];

        if (!MangerEmpID.length) return;

        // const fromDate = formatToDMY(defaultFromDate);
        // const toDate = formatToDMY(defaultToDate);

        filter = `EmployeeID IN (${MangerEmpID.join(",")}, '${EMPID}') AND Date BETWEEN '${defaultFromDate}'AND '${defaultToDate}'AND BillableMonth ='${currentMonthNumber}'AND BillableYear='${currentYear}'AND CompanyID ='${CompId}'`;
      }
    }

    console.log(EMPID, "--EMPID");

    if (AccessID == "TR366") {
      const savedFilters =
        JSON.parse(sessionStorage.getItem("TR366_Filters")) || null;

      if (savedFilters) {
        const conditions = [];

        // 🔹 FORMAT DATE HERE
        if (savedFilters.fromDate && savedFilters.toDate) {
          const fromDate = formatToDMY(savedFilters.fromDate);
          const toDate = formatToDMY(savedFilters.toDate);

          conditions.push(`Date BETWEEN '${fromDate}' AND '${toDate}'`);
        }

        if (savedFilters.attmonth) {
          conditions.push(`BillableMonth='${savedFilters.attmonth}'`);
        }

        if (savedFilters.attyear) {
          conditions.push(`BillableYear='${savedFilters.attyear}'`);
        }

        if (savedFilters.Employee?.length > 0) {
          const EmpIds = savedFilters.Employee.map(
            (e) => `'${e.RecordID}'`,
          ).join(",");
          conditions.push(`EmployeeID IN (${EmpIds})`);
        }

        if (savedFilters.project?.length > 0) {
          const projIds = savedFilters.project
            .map((p) => `'${p.RecordID}'`)
            .join(",");
          conditions.push(`ProjectID IN (${projIds})`);
        }

        conditions.push(`CompanyID ='${CompId}'`);

        filter = conditions.join(" AND ");
      } else {
        const MangerEmpID =
          JSON.parse(sessionStorage.getItem("MangerEmpID")) || [];

        if (!MangerEmpID.length) return;

        // const fromDate = formatToDMY(defaultFromDate);
        // const toDate = formatToDMY(defaultToDate);

        filter = `EmployeeID IN (${MangerEmpID.join(",")}, '${EMPID}') AND Date BETWEEN '${defaultFromDate}'AND '${defaultToDate}'AND BillableMonth ='${currentMonthNumber}'AND BillableYear='${currentYear}'AND CompanyID ='${CompId}'`;
      }
    }

    if (AccessID === "TR132") {
      console.log("-- TR132");

      if (filter === "") {
        const today = new Date();
        const oneMonthBeforeDate = new Date(today);
        oneMonthBeforeDate.setMonth(oneMonthBeforeDate.getMonth() - 1);

        const oneMonthBefore = oneMonthBeforeDate.toISOString().split("T")[0];
        const currentDate = new Date().toISOString().split("T")[0];

        const sessionFromDate = sessionStorage.getItem("FromDate");
        const sessionToDate = sessionStorage.getItem("ToDate");
        const sessionEmpID = sessionStorage.getItem("EmployeeID") || EMPID;
        const statusFilters = [];
        if (sessionStorage.getItem("TR132_assigned") === "Y")
          statusFilters.push("'AS'");
        if (sessionStorage.getItem("TR132_scheduled") === "Y")
          statusFilters.push("'SH'");
        if (sessionStorage.getItem("TR132_inprogress") === "Y")
          statusFilters.push("'I'");
        if (sessionStorage.getItem("TR132_completed") === "Y")
          statusFilters.push("'C'");
        if (sessionStorage.getItem("TR132_approved") === "Y")
          statusFilters.push("'AP'");
        if (sessionStorage.getItem("TR132_rejected") === "Y")
          statusFilters.push("'RJ'");

        const sourceFilters = [];
        if (sessionStorage.getItem("TR132_self") === "Y")
          sourceFilters.push("'Self'");
        if (sessionStorage.getItem("TR132_manager") === "Y")
          sourceFilters.push("'Manager'");
        if (sessionStorage.getItem("TR132_sprint") === "Y")
          sourceFilters.push("'Sprint'");

        const conditions = [];
        conditions.push(`EmployeesID='${sessionEmpID}'`);

        // 🟢 INITIAL LOAD → no FromDate & no ToDate = apply special rule
        if (!sessionFromDate && !sessionToDate) {
          conditions.push(
            `(DAILYTASKDATE BETWEEN '${oneMonthBefore}' AND '${currentDate}'OR (FilterStatus = 'C' AND ApprovedBy IS NULL))`,
          );
        }
        // if (!sessionFromDate && !sessionToDate) {
        //   conditions.push(
        //     `(DAILYTASKDATE='${currentDate}' OR STATUS='Inprogress')`
        //   );
        // }

        // 🟡 WHEN USER SELECTS A DATE → use normal logic
        else {
          if (sessionFromDate && sessionToDate) {
            conditions.push(
              `DAILYTASKDATE BETWEEN '${sessionFromDate}' AND '${sessionToDate}'`,
            );
          } else if (sessionFromDate) {
            conditions.push(`DAILYTASKDATE >= '${sessionFromDate}'`);
          } else if (sessionToDate) {
            conditions.push(`DAILYTASKDATE <= '${sessionToDate}'`);
          }
        }
        if (statusFilters.length > 0) {
          conditions.push(`FilterStatus IN (${statusFilters.join(",")})`);
        }

        if (sourceFilters.length > 0) {
          conditions.push(`TaskSource IN (${sourceFilters.join(",")})`);
        }

        conditions.push(`CompanyID='${CompId}'`);

        filter = conditions.join(" AND ");
      }
    }

    if (AccessID === "TR354") {
      console.log("-- TR354");

      if (filter === "") {
        const today = new Date();
        const oneMonthBeforeDate = new Date(today);
        oneMonthBeforeDate.setMonth(oneMonthBeforeDate.getMonth() - 1);

        const oneMonthBefore = oneMonthBeforeDate.toISOString().split("T")[0];
        const currentDate = new Date().toISOString().split("T")[0];

        const sessionFromDate = sessionStorage.getItem("FromDate");
        const sessionToDate = sessionStorage.getItem("ToDate");
        const sessionEmpID = sessionStorage.getItem("EmployeeID") || EMPID;
        const statusFilters = [];
        if (sessionStorage.getItem("TR354_assigned") === "Y")
          statusFilters.push("'AS'");
        if (sessionStorage.getItem("TR354_scheduled") === "Y")
          statusFilters.push("'SH'");
        if (sessionStorage.getItem("TR354_inprogress") === "Y")
          statusFilters.push("'I'");
        if (sessionStorage.getItem("TR354_completed") === "Y")
          statusFilters.push("'C'");
        if (sessionStorage.getItem("TR354_approved") === "Y")
          statusFilters.push("'AP'");
        if (sessionStorage.getItem("TR354_rejected") === "Y")
          statusFilters.push("'RJ'");

        const sourceFilters = [];
        if (sessionStorage.getItem("TR354_Teacher") === "Y")
          sourceFilters.push("'Teacher'");
        // if (sessionStorage.getItem("TR354_self") === "Y")
        //   sourceFilters.push("'Self'");
        // if (sessionStorage.getItem("TR354_manager") === "Y")
        //   sourceFilters.push("'Manager'");
        // if (sessionStorage.getItem("TR354_sprint") === "Y")
        // sourceFilters.push("'Sprint'");

        const conditions = [];
        conditions.push(`EmployeesID='${sessionEmpID}'`);

        // 🟢 INITIAL LOAD → no FromDate & no ToDate = apply special rule
        if (!sessionFromDate && !sessionToDate) {
          conditions.push(
            `(DAILYTASKDATE BETWEEN '${oneMonthBefore}' AND '${currentDate}'OR (FilterStatus = 'C' AND ApprovedBy IS NULL))`,
          );
        }
        // if (!sessionFromDate && !sessionToDate) {
        //   conditions.push(
        //     `(DAILYTASKDATE='${currentDate}' OR STATUS='Inprogress')`
        //   );
        // }

        // 🟡 WHEN USER SELECTS A DATE → use normal logic
        else {
          if (sessionFromDate && sessionToDate) {
            conditions.push(
              `DAILYTASKDATE BETWEEN '${sessionFromDate}' AND '${sessionToDate}'`,
            );
          } else if (sessionFromDate) {
            conditions.push(`DAILYTASKDATE >= '${sessionFromDate}'`);
          } else if (sessionToDate) {
            conditions.push(`DAILYTASKDATE <= '${sessionToDate}'`);
          }
        }
        if (statusFilters.length > 0) {
          conditions.push(`FilterStatus IN (${statusFilters.join(",")})`);
        }

        if (sourceFilters.length > 0) {
          conditions.push(`TaskSource IN (${sourceFilters.join(",")})`);
        }

        conditions.push(`CompanyID='${CompId}'`);

        filter = conditions.join(" AND ");
      }
    }

    if (AccessID == "TR133") {
      filter = `CompanyID='${CompId}'`;
    }
    if (AccessID == "TR269") {
      filter = `InchargeID= '${EMPID}' AND CompanyID='${CompId}'`;
    }
    // if (AccessID == "TR133" || AccessID == "TR276") {
    //   filter = `EmployeeID= '${EMPID}' AND CompanyID='${CompId}'`;
    // }
    if (AccessID == "TR133") {
      filter = `EmployeeID= '${EMPID}' AND CompanyID='${CompId}'`;
    }
    if (AccessID == "TR276") {
      filter = `EmployeeID= '${EMPID}' AND CompanyID='${CompId}'`;
    }
    if (AccessID == "TR276") {
      filter = `EmployeeID= '${EMPID}' AND InchargeID = '${EMPID}' AND CompanyID='${CompId}' AND (ServiceMaintenanceProject='Y' OR RoutineTasks='Y')`;
    }
    console.log(EMPID, "--EMPID");
    if (AccessID == "TR124") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR136") {
      filter = `EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR208") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR216") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR160") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR266") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR365") {
      filter = `AssignedBy ='${EMPID}'`;
    }
    //  if (AccessID == "TR368") {
    //   filter = `CompanyID ='${CompId}'`;
    // }
    if (AccessID == "TR271") {
      filter = ` EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR219") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    if (AccessID == "TR242") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
       if (AccessID == "TR381") {
      filter = `CompanyID ='${CompId}' AND EmployeeID='${EMPID}'`;
    }
    // if (AccessID == "TR245") {
    //   filter = `CompanyID ='${CompId}' AND parentID='${EMPID}'`;
    // }
    // if (AccessID == "TR290") {
    //   filter = `EmployeeID='${EMPID}'`;
    // }
    if (AccessID == "TR308") {
      filter = "";
    }
    // if (AccessID == "TR284") {
    //   filter = `EmployeeID='${EMPID}'`;
    // }
    // if (AccessID == "TR289") {
    //   filter = `EmployeeID='${EMPID}'`;
    // }

    var idata = {
      Query: {
        // "ScreenName": screenName,
        AccessID: AccessID,
        ScreenName: screenName,
        Filter: filter,
        Any: any,
        CompId,
        VerticalLicense: `${is003Subscription ? sliceSubscriptionCode : ""}`,
      },
    };

    idata = JSON.stringify(idata);
    console.log("data--" + idata);
    const requestId = nanoid();

    dispatch(pending({ requestId }));

    // dispatch(pending());

    axios
      .get(url, {
        params: {
          data: idata,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })
      .then((response) => {
        console.log("without authorization---" + JSON.stringify(response));
        var listviewData = response.data;

        if (listviewData.Status == "Y") {
          var obj = {};
          if (AccessID == "TR047") {
            obj = {
              field: "action",
              headerName: "Action",
              headerAlign: "center",
              sortable: false,
              filterable: false,
              disableColumnMenu: true,
              minWidth: 300,
              maxWidth: 300,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Stack direction="row">
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}/${params.row.Number}/${params.row.Quantity}`}
                    >
                      <Tooltip title="Production Card Items">
                        <IconButton color="info">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {/* <Link to={`/Apps/Secondarylistview/${params.row.ChildID1}/${params.row.ChildName1}/${params.row.Type}/${params.row.Number}`} > */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID1}/${params.row.ChildName1}/${params.row.RecordID}/${params.row.Number}`}
                    >
                      <Tooltip title="Indent Items">
                        <IconButton color="error">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {params.row.Process != "Y" && params.row.Completeddate ? (
                      <Link>
                        <IconButton
                          color="primary"
                          variant="contained"
                          onClick={fnProcess(params.row.RecordID, "TR047")}
                        >
                          <SettingsBackupRestoreIcon />
                        </IconButton>
                      </Link>
                    ) : null}

                    {params.row.Startdate == "" ? (
                      <Link>
                        <Tooltip title={params.row.Startdate}>
                          <IconButton
                            color="success"
                            onClick={productionCardUPdate(
                              "S",
                              params.row.RecordID,
                            )}
                          >
                            <PlayCircleOutlineOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Startdate != "" &&
                      params.row.Completeddate == "" ? (
                      <Box>
                        {params.row.Pausedate == "" ? (
                          <Link>
                            <Tooltip title={params.row.Pausedate || "Pause"}>
                              <IconButton
                                color="warning"
                                onClick={productionCardUPdate(
                                  "P",
                                  params.row.RecordID,
                                )}
                              >
                                <PauseCircleOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : params.row.ContinueDate == "" ? (
                          <Link>
                            <Tooltip title="Continue">
                              <IconButton
                                color="primary"
                                onClick={productionCardUPdate(
                                  "R",
                                  params.row.RecordID,
                                )}
                              >
                                <NotStartedOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : (
                          false
                        )}
                        <Link>
                          <Tooltip
                            title={params.row.Completeddate || "Complete"}
                          >
                            <IconButton
                              color="success"
                              onClick={productionCardUPdate(
                                "C",
                                params.row.RecordID,
                              )}
                            >
                              <TaskAltOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </Box>
                    ) : (
                      ""
                    )}
                    {params.row.Process == "Y" ? (
                      <Tooltip title="Print">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }PRODUCTIONCARD.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color="info"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }PRODUCTIONCARD.php?Token=${
                                  params.row.Hashtoken
                                }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_006",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    {/* <Link><Tooltip title="Start"><IconButton color="success" onClick={productionCardUPdate("S",params.row.RecordID)} ><PlayCircleOutlineOutlinedIcon/></IconButton></Tooltip></Link>
             <Link><Tooltip title="Pause"><IconButton color="warning" onClick={productionCardUPdate("P",params.row.RecordID)}><PauseCircleOutlinedIcon/></IconButton></Tooltip></Link>
            <Link><Tooltip title="Complete"><IconButton color="success" onClick={productionCardUPdate("C",params.row.RecordID)}><TaskAltOutlinedIcon/></IconButton></Tooltip></Link> */}
                    {/* </Stack> */}
                  </Stack>
                );
              },
            };
          } else if (AccessID == "TR058" || AccessID == "TR059") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {/* // <Stack direction="row" spacing={1}> */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip
                        title={
                          AccessID == "TR058"
                            ? "List of Remarks"
                            : "List of Delivery challan"
                        }
                      >
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (AccessID == "TR076") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {/* // <Stack direction="row" spacing={1}> */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="List of Batch">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR245" ||
            AccessID == "TR248" ||
            AccessID == "TR247" ||
            AccessID == "TR246" ||
            AccessID == "TR254" ||
            AccessID == "TR267" ||
            AccessID == "TR272" ||
            AccessID == "TR255" ||
            AccessID == "TR256" 
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 390,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              // align: "center",
              align: "left",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => (
                <EmployeeAction
                  key={params.row.SLNO}
                  params={params}
                  accessID={AccessID}
                />
              ),
            };
          } else if (
            AccessID == "TR290" ||
            AccessID == "TR308" ||
            AccessID == "TR307" ||
            AccessID == "TR284" ||
            // AccessID == "TR342" ||
            AccessID == "TR352" ||
            AccessID == "TR368" ||
            AccessID == "TR289"            
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "left",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => (
                <AssessmentAction
                  params={params}
                  accessID={AccessID}
                  screenName={screenName}
                />
              ),
            };
          } else if (AccessID == "TR270") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "left",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => (
                <RoutineTaskAction
                  params={params}
                  accessID={AccessID}
                  screenName={screenName}
                />
              ),
            };
          } else if (AccessID == "TR064") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {/* // <Stack direction="row" spacing={1}> */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="List of Stock">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (AccessID == "TR049") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {/* // <Stack direction="row" spacing={1}> */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="List of UOM">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          }
        
        else if (AccessID == "TR392") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                        // to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        to={`/Apps/Secondarylistview/TR332/Payment/${params.row.RecordID}/${params.row.EmployeeID}`}
                        state={{
                          Employee: params.row.Employee,
                          Project: params.row.Project,
                          ProjectID: params.row.ProjectID,
                        }}
                      >
                        <Tooltip title="Payment">
                          <IconButton color="info" size="small">
                            <CurrencyRupeeOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                  </Box>
                );
              },
            };
          } 
          //Sprint Screen
          else if (AccessID == "TR269") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 300,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      to={`/Apps/Secondarylistview/TR262/Sprint/${params.row.RecordID}`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        projectName: params.row.Name,
                      }}
                    >
                      <Tooltip title="Sprint">
                        <IconButton color="info" size="small">
                          <TaskAltIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {/* <Link
                      to={`/Apps/Secondarylistview/TR270/Routine Tasks/${params.row.RecordID}`}
                      state={{ code: params.row.Code, Desc: params.row.Name, MilestoneID: params.row.RecordID, projectID: params.row.ProjectID, OperationStageID: params.row.OperationStageID, ProjectName: params.row.Project }}
                    >
                      <Tooltip title="Routine Tasks">
                        <IconButton color="info" size="small">
                          <TransferWithinAStationIcon />
                        </IconButton>
                      </Tooltip>
                    </Link> */}

                    <Box
                      sx={{
                        position: "relative",
                        width: 120,
                        height: 10,
                        backgroundColor: "#e0e0e0",
                        overflow: "hidden",
                        flexShrink: 0,
                        borderRadius: 0, // <- no rounded corners
                      }}
                    >
                      {/* <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${progressData.DE}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${progressData.NO}%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                      <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${params.row.ProjectCompletedWeightage}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          // left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${
                            Number(params.row.Weightages) -
                            Number(params.row.ProjectCompletedWeightage)
                          }%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      {/* <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                    </Box>
                  </Box>
                );
              },
            };
          } else if (AccessID == "TR276") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 300,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    {/* <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/E`}
                      state={{
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        //MilestoneName:params.row.MilestoneName,
                        Activityname: params.row.ActivitesName,
                        TaskName: params.row.Name,
                        projectName: params.row.ProjectName,
                        stagesName: params.row.OperationStageName,
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link> */}
                    <Link
                      to={`/Apps/Secondarylistview/TR270/Routine Tasks/${params.row.RecordID}`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        ProjectName: params.row.Project,
                      }}
                    >
                      <Tooltip title="Routine Tasks">
                        <IconButton color="info" size="small">
                          <TransferWithinAStationIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          }
          //Project Weightages
          else if (AccessID == "TR133") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 400,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    {/* {
                      isManager == 0 && isprojectmanager == "Y" && (
                        
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/E`}
                          state={{
                            MilestoneID: params.row.RecordID,
                            projectID: params.row.ProjectID,
                            //MilestoneName:params.row.MilestoneName,
                            Activityname: params.row.ActivitesName,
                            TaskName: params.row.Name,
                            projectName: params.row.ProjectName,
                            stagesName: params.row.OperationStageName,
                          }}
                        >
                          <Tooltip title="Edit">
                            <IconButton color="info" size="small">
                              <ModeEditOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )
                     
                    } */}

                    {!is003Subscription ? (
                      <>
                        <Link
                          to={`/Apps/Secondarylistview/TR233/Milestones/${params.row.RecordID}`}
                          state={{
                            code: params.row.Code,
                            Desc: params.row.Name,
                            MilestoneID: params.row.RecordID,
                            projectID: params.row.ProjectID,
                            OperationStageID: params.row.OperationStageID,
                            projectName: params.row.Name,
                          }}
                        >
                          <Tooltip
                            title={is003Subscription ? "Section" : "Milestone"}
                          >
                            <IconButton color="info" size="small">
                              <FlagIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>

                        <Link
                          to={`/Apps/TR233/weightage/Editweightage/M/${params.row.RecordID}/E`}
                          state={{
                            code: params.row.Code,
                            Desc: params.row.Name,
                            MilestoneID: params.row.RecordID,
                            projectID: params.row.ProjectID,
                            OperationStageID: params.row.OperationStageID,
                            projectName: params.row.Name,
                          }}
                        >
                          <Tooltip title="Milestone Weightage">
                            <IconButton color="info" size="small">
                              <BalanceIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>

                        {/* <Link
                      to={`/Apps/Secondarylistview/TR262/Sprint/${params.row.RecordID}`}
                      state={{ code: params.row.Code, Desc: params.row.Name, MilestoneID: params.row.RecordID, projectID: params.row.ProjectID, OperationStageID: params.row.OperationStageID, projectName: params.row.Name }}
                    >
                      <Tooltip title="Sprint">
                        <IconButton color="info" size="small">
                          <TaskAltIcon />
                        </IconButton>
                      </Tooltip>
                    </Link> */}
                      </>
                    ) : (
                      <>
                        <Link
                          to={`/Apps/Secondarylistview/TR368/TimeTable/${params.row.RecordID}`}
                          state={{
                            // MilestoneID: params.row.RecordID,
                            projectID: params.row.RecordID,
                            MilestoneName: params.row.Name,
                            projectName: params.row.Project,
                            BreadCrumb1: params.row.Project,
                          }}
                        >
                          <Tooltip title="Time Table">
                            <IconButton color="info" size="small">
                              <DatasetLinkedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </>
                    )}
                    <Link
                      to={`/Apps/Role/EditRole/M/${params.row.RecordID}/${params.row.EmployeeID}/E`}
                      // to={`/Apps/Role/EditRole/M/${params.row.RecordID}/${params.row.ProjectIncharge}/E`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        projectName: params.row.Name,
                      }}
                    >
                      {/* <Tooltip title="Team Project"> */}
                      <Tooltip
                        title={
                          is003Subscription
                            ? "Class Teachers And Students"
                            : "Team Project"
                        }
                      >
                        <IconButton color="info" size="small">
                          <PeopleAltIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {is002Subscription && (
                    <Link
                      to={`/Apps/ResourceAllocation/${params.row.RecordID}/${params.row.EmployeeID}`}
                      // to={`/Apps/Role/EditRole/M/${params.row.RecordID}/${params.row.ProjectIncharge}/E`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        projectName: params.row.Name,
                      }}
                    >
                      <Tooltip
                        // title={"Effort Allocation"}
                        title={"RVA"}
                      >
                        <IconButton color="info" size="small">
                          <AssignmentIndOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>)}

                    {!is003Subscription && (
                      <Box
                        sx={{
                          position: "relative",
                          width: 120,
                          height: 10,
                          backgroundColor: "#e0e0e0",
                          overflow: "hidden",
                          flexShrink: 0,
                          borderRadius: 0, // <- no rounded corners
                        }}
                      >
                        {/* <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${progressData.DE}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${progressData.NO}%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                        <Box
                          sx={{
                            position: "absolute",
                            height: "100%",
                            width: `${params.row.ProjectCompletedWeightage}%`,
                            backgroundColor: "green",
                          }}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            // left: `${progressData.DE}%`,
                            height: "100%",
                            width: `${
                              Number(params.row.Weightages) -
                              Number(params.row.ProjectCompletedWeightage)
                            }%`,
                            backgroundColor: "#FFDE21",
                          }}
                        />
                        {/* <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                      </Box>
                    )}
                  </Box>
                );
              },
            };
          }
          //Milestone Weightages
          else if (AccessID == "TR233") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 350,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/E`}
                      state={{
                        MilestoneID: params.row.RecordID,
                        projectID: params.row.ProjectID,
                        //MilestoneName:params.row.MilestoneName,
                        Activityname: params.row.ActivitesName,
                        TaskName: params.row.Name,
                        projectName: params.row.ProjectName,
                        stagesName: params.row.OperationStageName,
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {is003Subscription ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR368/Timetable/${params.row.RecordID}`}
                        state={{
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          MilestoneName: params.row.Name,
                          MilestoneName: params.row.Name,
                          projectName: params.row.ProjectName,
                        }}
                      >
                        <Tooltip title="Timetable">
                          <IconButton color="info" size="small">
                            <DatasetLinkedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      <>
                        <Link
                          to={`/Apps/Secondarylistview/TR236/Stages/${params.row.RecordID}`}
                          state={{
                            MilestoneID: params.row.RecordID,
                            projectID: params.row.ProjectID,
                            MilestoneName: params.row.Name,
                            MilestoneName: params.row.Name,
                            projectName: params.row.ProjectName,
                          }}
                        >
                          <Tooltip title="Stages">
                            <IconButton color="info" size="small">
                              <ArtTrackIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>

                        <Link
                          to={`/Apps/TR233/weightage/Editweightage/OPS/${params.row.RecordID}/E`}
                          state={{
                            code: params.row.Code,
                            Desc: params.row.Name,
                            MilestoneID: params.row.RecordID,
                            MilestoneName: params.row.Name,
                            projectID: params.row.ProjectID,
                            OperationStageID: params.row.OperationStageID,
                            projectName: params.row.ProjectName,
                          }}
                        >
                          <Tooltip title="Stage Weightage">
                            <IconButton color="info" size="small">
                              <BalanceIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </>
                    )}

                    <Box
                      sx={{
                        position: "relative",
                        width: 120,
                        height: 10,
                        backgroundColor: "#e0e0e0",
                        overflow: "hidden",
                        flexShrink: 0,
                        borderRadius: 0, // <- no rounded corners
                      }}
                    >
                      {/* <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${progressData.DE}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${progressData.NO}%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                      <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${params.row.MilestonesCompletedWeightage}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          // left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${
                            Number(params.row.Weightages) -
                            Number(params.row.MilestonesCompletedWeightage)
                          }%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      {/* <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                    </Box>
                  </Box>
                );
              },
            };
          }
          //Timetable
          // else if (AccessID == "TR368") {
          //   obj = {
          //     field: "action",
          //     headerName: "Action",
          //     minWidth: 350,
          //     sortable: false,
          //     headerAlign: "center",
          //     filterable: false,
          //     align: "center",
          //     disableColumnMenu: true,
          //     disableExport: true,
          //     renderCell: (params) => {
          //       return (
          //         <Box display="flex" alignItems="center" gap={1}>
          //           <Link
          //             to={`./Edit${screenName}/${params.row.RecordID}/E`}
          //             state={{
          //               MilestoneID: params.row.Section,
          //               MilestoneName: params.row.MilestoneDesc,
          //               projectID: params.row.StandardID,
          //               projectName: params.row.ProjectDesc,
          //             }}
          //           >
          //             <Tooltip title="Edit">
          //               <IconButton color="info" size="small">
          //                 <ModeEditOutlinedIcon />
          //               </IconButton>
          //             </Tooltip>
          //           </Link>

          //           {/* <Link
          //             to={`./Edit${screenName}/${params.row.RecordID}/C`}
          //             state={{
          //               MilestoneID: params.row.Section,
          //               MilestoneName: params.row.MilestoneDesc,
          //               projectID: params.row.StandardID,
          //               projectName: params.row.ProjectDesc,
          //             }}
          //           >
          //             <Tooltip title="Std Calendar">
          //               <IconButton color="info" size="small">
          //                 <RecentActorsIcon />
          //               </IconButton>
          //             </Tooltip>
          //           </Link> */}
          //           <Link
          //             to={`./ProjectTimeTable`}
          //             state={{
          //               MilestoneID: params.row.Section,
          //               MilestoneName: params.row.MilestoneDesc,
          //               TermsID: params.row.TermID,
          //               projectID: params.row.StandardID,
          //               projectName: params.row.ProjectDesc,
          //               Description: params.row.Description,
          //             }}
          //           >
          //             <Tooltip title="Timetable">
          //               <IconButton color="info" size="small">
          //                 <CalendarMonthOutlinedIcon />
          //               </IconButton>
          //             </Tooltip>
          //           </Link>
          //         </Box>
          //       );
          //     },
          //   };
          // }
          //Stages Weightages
          else if (AccessID == "TR236") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 350,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/E`}
                      state={{
                        MilestoneID: params.row.MilestoneID,
                        projectID: params.row.ProjectID,
                        MilestoneName: params.row.MilestoneName,
                        Activityname: params.row.ActivitesName,
                        TaskName: params.row.Name,
                        projectName: params.row.ProjectName,
                        stagesName: params.row.OperationStageName,
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Link
                      to={`/Apps/Secondarylistview/TR234/Activities/${params.row.RecordID}`}
                      state={{
                        MilestoneID: params.row.MilestoneID,
                        MilestoneName: params.row.MilestoneName,
                        stagesName: params.row.Name,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        projectName: params.row.ProjectName,
                      }}
                    >
                      <Tooltip title="Activities">
                        <IconButton color="info" size="small">
                          <StreamIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Link
                      to={`/Apps/TR233/weightage/Editweightage/ACT/${params.row.RecordID}/E`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        MilestoneName: params.row.MilestoneName,
                        stagesName: params.row.Name,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        projectName: params.row.ProjectName,
                      }}
                    >
                      <Tooltip title="Activity Weightage">
                        <IconButton color="info" size="small">
                          <BalanceIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Box
                      sx={{
                        position: "relative",
                        width: 120,
                        height: 10,
                        backgroundColor: "#e0e0e0",
                        overflow: "hidden",
                        flexShrink: 0,
                        borderRadius: 0, // <- no rounded corners
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${params.row.OperationstageCompletedWeightage}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          // left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${
                            Number(params.row.Weightages) -
                            Number(params.row.OperationstageCompletedWeightage)
                          }%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      {/* <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                    </Box>
                  </Box>
                );
              },
            };
          }


          //For Feedback Complaints
           else if (AccessID == "TR391") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 350,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    {params.row.Status !== "Replied" ? (
                      <Link
                        to={`/Apps/TR391/Feedback/EditFeedback/${params.row.RecordID}/E`}
                        state={{
                          Breadcrumb1: params.row.Title,
                          Status:params.row.Status
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                     <Link
                        to={`/Apps/TR391/Feedback/EditFeedback/${params.row.RecordID}/V`}
                        state={{
                          Breadcrumb1: params.row.Title,
                          Status:params.row.Status
                        }}
                      >
                        <Tooltip title="View">
                          <IconButton color="info" size="small">
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                  </Box>
                );
              },
            };
          }

          //Activities Weightages
          else if (AccessID == "TR234") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 350,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/E`}
                      state={{
                        MilestoneID: params.row.MilestoneID,
                        Activityname: params.row.Name,
                        MilestoneName: params.row.MilestoneName,
                        projectID: params.row.ProjectID,
                        stagesName: params.row.OperationStageName,
                        projectName: params.row.ProjectName,
                        OperationStageID: params.row.OperationStageID,
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Link
                      to={`/Apps/Secondarylistview/TR235/Task/${params.row.RecordID}`}
                      state={{
                        MilestoneID: params.row.MilestoneID,
                        Activityname: params.row.Name,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        MilestoneName: params.row.MilestoneName,
                        stagesName: params.row.OperationStageName,
                        projectName: params.row.ProjectName,
                      }}
                    >
                      <Tooltip title="Task">
                        <IconButton color="info" size="small">
                          <TaskIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    <Link
                      to={`/Apps/TR233/weightage/Editweightage/TK/${params.row.RecordID}/E`}
                      state={{
                        code: params.row.Code,
                        Desc: params.row.Name,
                        MilestoneID: params.row.MilestoneID,
                        projectID: params.row.ProjectID,
                        OperationStageID: params.row.OperationStageID,
                        MilestoneName: params.row.MilestoneName,
                        stagesName: params.row.OperationStageName,
                        projectName: params.row.ProjectName,
                        Activityname: params.row.Name,
                      }}
                    >
                      <Tooltip title="Task Weightage">
                        <IconButton color="info" size="small">
                          <BalanceIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Box
                      sx={{
                        position: "relative",
                        width: 100,
                        height: 10,
                        backgroundColor: "#e0e0e0",
                        overflow: "hidden",
                        flexShrink: 0,
                        borderRadius: 0, // <- no rounded corners
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${params.row.ActivitesCompletedWeightage}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          // left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${
                            Number(params.row.Weightages) -
                            Number(params.row.ActivitesCompletedWeightage)
                          }%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                    </Box>
                  </Box>
                );
              },
            };
          }

          //Task Weightages
          else if (AccessID == "TR235") {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 300,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/E`}
                      state={{
                        TaskName: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        MilestoneName: params.row.MilestoneName,
                        Activityname: params.row.ActivitesName,
                        projectID: params.row.ProjectID,
                        projectName: params.row.ProjectName,
                        OperationStageID: params.row.OperationStageID,
                        stagesName: params.row.OperationStageName,
                      }}
                      //state ={{MilestoneID:params.row.MilestoneID,projectID:params.row.ProjectID,OperationStageID:params.row.OperationStageID}}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      state={{
                        TaskName: params.row.Name,
                        MilestoneID: params.row.RecordID,
                        MilestoneName: params.row.MilestoneName,
                        Activityname: params.row.ActivitesName,
                        projectID: params.row.ProjectID,
                        projectName: params.row.ProjectName,
                        OperationStageID: params.row.OperationStageID,
                        stagesName: params.row.OperationStageName,
                      }}
                    >
                      <Tooltip title="Attachment">
                        <IconButton color="info" size="small">
                          <AttachFileIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Box
                      sx={{
                        position: "relative",
                        width: 120,
                        height: 10,
                        backgroundColor: "#e0e0e0",
                        overflow: "hidden",
                        flexShrink: 0,
                        borderRadius: 0, // <- no rounded corners
                      }}
                    >
                      {/* <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${progressData.DE}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${progressData.NO}%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                      <Box
                        sx={{
                          position: "absolute",
                          height: "100%",
                          width: `${params.row.TaskCompletedWeightage}%`,
                          backgroundColor: "green",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          // left: `${progressData.DE}%`,
                          height: "100%",
                          width: `${
                            Number(params.row.Weightages) -
                            Number(params.row.TaskCompletedWeightage)
                          }%`,
                          backgroundColor: "#FFDE21",
                        }}
                      />
                      {/* <Box
                        sx={{
                          position: "absolute",
                          left: `${progressData.DE + progressData.NO}%`,
                          height: "100%",
                          width: `${progressData.SW}%`,
                          backgroundColor: "#e74c3c",
                        }}
                      /> */}
                    </Box>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR063"
            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              filterable: false,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`./Edit${screenName}/${params.row.RecordID}/${params.row.YearID}/E`}
                    >
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ModeEditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR043"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 150,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {params.row.Code == "P" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR073/${params.row.ChildName}/${params.row.Type}`}
                      >
                        <Tooltip title="List Of Invoice">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Code == "L" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR011/Proforma Invoice/${params.row.Code}/FI`}
                      >
                        <Tooltip title="List Of Invoice">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : null}

                    {params.row.Code == "PL" || params.row.Code == "LL" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR084/Local Invoice/${params.row.Code}/${params.row.Type}`}
                      >
                        <Tooltip title="List Of Invoice">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : null}

                    {/* ( <Link to={`/Apps/Secondarylistview/TR083/Local Invoce/${params.row.Type}/IN`}>
                      <Tooltip title="Edit">
                        <IconButton color="info" size="small">
                          <ReceiptLongIcon />
                        </IconButton>
                      </Tooltip>
                  </Link>) */}
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR044"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              sortable: false,
              filterable: false,
              headerAlign: "center",
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="List of Category">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          }
          // STOCKENQUIRY
          else if (
            AccessID == "TR078"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 150,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              align: "center",
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {params.row.Type == "S" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.SuppChildID}/${params.row.SuppChildName}/${params.row.Type}/${params.row.Description}`}
                      >
                        <Tooltip title="List Of Stock">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Type == "PD" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.PrdcrdChildID}/${params.row.PrdcrdChildName}/${params.row.Type}`}
                      >
                        <Tooltip title="List Of Stock">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Type == "L" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.PrdcrdChildID}/${params.row.PrdcrdChildName}/${params.row.parentID}/${params.row.Type}`}
                      >
                        <Tooltip title="List Of Stock">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Type == "CC" || params.row.Type == "PC" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}/${params.row.Code}`}
                      >
                        <Tooltip title="List Of Stock">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.RemarkChildID}/${params.row.RemarkChildName}/${params.row.Code}`}
                      >
                        <Tooltip title="List Of Stock">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR072"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}/${params.row.Description}`}
                    >
                      <Tooltip title="List Of Process">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR116"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              align: "center",
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="List Of Packing List">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR116"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                    >
                      <Tooltip title="">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          }
          //
          else if (
            AccessID == "TR087"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {params.row.parentID == "N" ? (
                      <Link to={`./EditPacking List/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      <Link
                        to={`/Apps/Secondarylistview/TR087/Packing List/${params.row.parentID}/EditAssorted/${params.row.RecordID}/E`}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {params.row.Process == "Y" ? (
                      <Tooltip title="Print">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }PACKINGLIST.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color="info"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }PACKINGLIST.php?Token=${params.row.Hashtoken}`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_010",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR072"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 150,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}/${params.row.Description}`}
                    >
                      <Tooltip title="List Of Process">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR073"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 150,
              sortable: false,
              headerAlign: "center",
              align: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.parentID}/${params.row.Code}`}
                    >
                      <Tooltip title={params.row.Description}>
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR079"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/TR080/Stock/${params.row.RecordID}/${params.row.Name}/${params.row.parentID}`}
                    >
                      <Tooltip title="Stock">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR051"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              align: "center",
              renderCell: (params) => {
                return (
                  <Box>
                    {/* <Tooltip title="Indent Order">
                        
                       <IconButton color="info" size="small" onClick={indentOrderSave('insert',params.row.RecordID)}>
                         <ReceiptLongIcon />
                       </IconButton>
                     </Tooltip> */}
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.MtlRecordID}/${params.row.ProductionCardNO}/${params.row.Type}`}
                    >
                      <Tooltip title="Edit">
                        <IconButton
                          color="info"
                          onClick={() =>
                            sessionStorage.setItem(
                              "indentRecID",
                              params.row.RecordID,
                            )
                          }
                          size="small"
                        >
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR113"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Link
                    to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}`}
                  >
                    <Tooltip title="Edit">
                      <IconButton color="info" size="small">
                        <ListAltOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Link>
                );
              },
            };
          } else if (
            AccessID == "TR111"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Link
                    to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}/${params.row.Name}`}
                  >
                    <Tooltip title="Edit">
                      <IconButton color="info" size="small">
                        <ListAltOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Link>
                );
              },
            };
          } else if (
            AccessID == "TR101"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    {params.row.Code === "CR" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID1}/${params.row.ChildName1}/${params.row.RecordID}`}
                      >
                        <Tooltip title="List Of Invoice">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Code}/${params.row.RecordID}`}
                      >
                        <Tooltip title="List Of Invoice">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR103"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Description}/${params.row.RecordID}`}
                      state={{ rowData: params.row }}
                    >
                      <Tooltip title="List Of Invoice">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR104"

            // AccessID == "TR060"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 100,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Box>
                    <Link
                      to={`./${params.row.ChildID}/${params.row.ChildName}/${params.row.Description}`}
                    >
                      <Tooltip title="List Of Invoice">
                        <IconButton color="info" size="small">
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </Box>
                );
              },
            };
          } else if (
            AccessID == "TR236" ||
            AccessID == "TR234" ||
            AccessID == "TR132" ||
            AccessID == "TR354" ||
            AccessID == "TR263" ||
            AccessID == "TR353" ||
            AccessID == "TR266" ||
            AccessID == "TR365" ||
            // AccessID == "TR368" ||
            AccessID == "TR208" ||
            AccessID == "TR219" ||
            AccessID == "TR242" ||
            AccessID == "TR086" ||
            AccessID == "TR331" ||
            AccessID == "TR366" ||
            AccessID == "TR216" ||
            AccessID == "TR160" ||
            AccessID == "TR235" ||
            AccessID == "TR233" ||
            AccessID == "TR262" ||
            AccessID == "TR293" ||
            // AccessID == "TR390" ||
            AccessID == "TR264"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              //minWidth: 150,
              width: 200,
              sortable: false,
              headerAlign: "center",
              filterable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                const handleGenerate = async (rowData) => {
                  try {
                    // 1️⃣ SprintInvoicegenerate
                    const generateRes = await dispatch(
                      SprintInvoicegenerate({
                        CompanyID: rowData.CompanyID,
                        DailytaskID: rowData.RecordID,
                      }),
                    );

                    // 2️⃣ Check Status === "Y"
                    if (generateRes.payload.Status === "N") {
                      toast.error(
                        generateRes.payload.Msg || "Invoice generation failed",
                      );
                      return;
                    }
                    // else if (generateRes.payload.Status === "U") {
                    //   toast.error(generateRes.payload.Msg || "Pdf already generated");
                    // }

                    toast.success(
                      generateRes.payload.Msg ||
                        "Invoice generated successfully",
                    );

                    // 3️⃣ SprintInvoiceGet → HeaderData + DetailData → PDF generation → Open PDF
                    const getRes = await dispatch(
                      SprintInvoiceGet({
                        Source: "DailyTask",
                        CompanyID: rowData.CompanyID,
                        DailytaskID: rowData.RecordID,
                      }),
                    );

                    const data = getRes.payload;

                    if (!data?.HeaderData || !data?.DetailData?.length) {
                      toast.error("Invoice data not available");
                      return;
                    }

                    // 4️⃣ PDF generation → Open PDF
                    const blob = await pdf(
                      <SprintInvoiceDocument
                        invoice={data.HeaderData}
                        detailData={data.DetailData}
                      />,
                    ).toBlob();

                    const url = URL.createObjectURL(blob);
                    window.open(url, "_blank");
                  } catch (err) {
                    console.error(err);
                    toast.error("Something went wrong");
                  }
                };

                // Simplified PDFButton - now only for VIEWING existing invoices
                const PDFButton = ({
                  DailytaskID,
                  CompanyID,
                  TaskSource,
                  AdditionallyBillable,
                  TaskStatus,
                }) => {
                  const [loading, setLoading] = React.useState(false);

                  const isEnabled =
                    TaskSource === "Sprint" &&
                    AdditionallyBillable === "Y" &&
                    TaskStatus === "Approved";

                  const handleClick = async () => {
                    if (!isEnabled) return;
                    setLoading(true);

                    try {
                      // Same flow: generate → check status → get → PDF → open
                      await handleGenerate({
                        CompanyID,
                        RecordID: DailytaskID,
                      });
                    } finally {
                      setLoading(false);
                    }
                  };

                  return (
                    <Tooltip
                      title={isEnabled ? "Generate & View PDF" : "Not enabled"}
                    >
                      <span>
                        <IconButton
                          size="small"
                          disabled={!isEnabled || loading}
                          onClick={handleClick}
                        >
                          {loading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <PictureAsPdfIcon
                              color={isEnabled ? "error" : "disabled"}
                            />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  );
                };

                return (
                  <Box>
                    {filter != `EmployeeID='${EMPID}'` &&
                      params.row.Status != "Approved" &&
                      // AccessID == "TR264" && (
                      AccessID == "TR293" && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/AP`}
                        >
                          <Tooltip title="Approve">
                            <IconButton color="info" size="small">
                              <DoneIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {filter != `EmployeeID='${EMPID}'` &&
                      // AccessID == "TR264" && (
                      AccessID == "TR293" && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/QR`}
                        >
                          <Tooltip title="Query">
                            <IconButton color="info" size="small">
                              <ContactSupportIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {filter == `EmployeeID='${EMPID}'` &&
                      // AccessID == "TR264" && (
                      AccessID == "TR293" && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/V`}
                        >
                          <Tooltip title="View">
                            <IconButton color="info" size="small">
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {filter != `EmployeeID='${EMPID}'` &&
                      params.row.Status == "Approved" &&
                      // AccessID == "TR264" && (
                      AccessID == "TR293" && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/V`}
                        >
                          <Tooltip title="View">
                            <IconButton color="info" size="small">
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {(AccessID == "TR132" || AccessID == "TR354") &&
                    (params.row.Status === "Assigned" ||
                      params.row.Status === "Scheduled") ? (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/P`}>
                        <Tooltip title="Pick Now">
                          <IconButton color="info" size="small">
                            <DoneOutlineIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      <>
                        {(AccessID == "TR132" || AccessID == "TR354") &&
                        params.row.Status != "Dependence" &&
                        (params.row.Status == "Completed" ||
                          params.row.Status === "Inprogress" ||
                          params.row.Status == "Not yet started" ||
                          params.row.Status == "Rejected" ||
                          params.row.Status == "Query") ? (
                          <Link
                            to={`./Edit${screenName}/${params.row.RecordID}/E`}
                          >
                            <Tooltip title="Edit">
                              <IconButton color="info" size="small">
                                <ModeEditOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : (
                          false
                        )}

                        {(AccessID == "TR132" || AccessID == "TR354") &&
                        params.row.Status == "Inprogress" ? (
                          // &&
                          // params.row.Status != "Dependence"  &&
                          // && (params.row.Status != "Transfer Out" && params.row.Status != "Approved" && params.row.Transfer != -1)
                          // (params.row.Status == "Completed" ||
                          //   params.row.Status === "Inprogress" ||
                          //   params.row.Status == "Not yet started") ?
                          <Link
                            to={`./Edit${screenName}/${params.row.RecordID}/U`}
                          >
                            <Tooltip title="Update">
                              <IconButton color="info" size="small">
                                <UpdateIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : (
                          false
                        )}

                        {(AccessID == "TR132" || AccessID == "TR354") &&
                        (params.row.Status == "Approved" ||
                          params.row.Status == "Blocked") ? (
                          <Link
                            to={`./Edit${screenName}/${params.row.RecordID}/V`}
                          >
                            <Tooltip title="View">
                              <IconButton color="info" size="small">
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : (
                          false
                        )}
                        {/* {AccessID == "TR132" &&
                          (params.row.Status == "Dependence") ? (

                          <Tooltip title="Dependency">
                            <IconButton color="info" size="small">
                              <EscalatorWarningIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          false
                        )} */}
                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          (params.row.Status === "Inprogress" ||
                            params.row.Status == "Not yet started") && (
                            <Link
                              to={`./Edit${screenName}/${params.row.RecordID}/C`}
                            >
                              <Tooltip title="Completed">
                                <IconButton color="success" size="small">
                                  <AssignmentTurnedInIcon />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}

                        {/* { AccessID == "TR132" && params.row.Status != "Completed" &&<Link
                        to={`./Edit${screenName}/${params.row.RecordID}/T`}
                        state={{
                          MilestoneID:params.row.RecordID,projectID:params.row.ProjectID,
                          MilestoneName:params.row.MilestoneName,
                          Activityname:params.row.ActivitesName,TaskName:params.row.Name,projectName:params.row.ProjectName,stagesName:params.row.OperationStageName
                        }}
                      >
                       
                        <Tooltip title="Transfer">
                          <IconButton color="info" size="small">
                            <SwapHorizIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>}  */}

                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          params.row.Status == "Transfer In" &&
                          params.row.Transfer == 1 && (
                            <Link
                              to={`./Edit${screenName}/${params.row.RecordID}/T`}
                            >
                              <Tooltip title="Transfer In">
                                <IconButton 
                                // color="warning" 
                                color="info" 
                                size="small">
                                  <UndoIcon />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}

                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          params.row.Status == "Transfer Out" &&
                          params.row.Transfer == -1 && (
                            <Link
                              to={`./Edit${screenName}/${params.row.RecordID}/TO`}
                            >
                              <Tooltip title="Transfer Out">
                                <IconButton 
                                // color="info" CHANGED ON 19/05/2026 AS ASKED BY NK ANNA
                                color="warning"
                                 size="small">
                                  <RedoIcon />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}

                        {/* {AccessID == "TR132" && (params.row.Status != "Completed" && params.row.Status != "Approved")?  */}
                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          params.row.Status === "Inprogress" &&
                          params.row.Status != "Blocked" &&
                          params.row.TaskSource != "Self" && (
                            <Link
                              to={`./Edit${screenName}/${params.row.RecordID}/B`}
                            >
                              <Tooltip title="Blocked">
                                <IconButton color="info" size="small">
                                  <BlockIcon />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}

                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          params.row.Status == "Blocked" &&
                          params.row.Transfer != "-1" && (
                            <Link
                              to={`./Edit${screenName}/${params.row.RecordID}/UB`}
                            >
                              <Tooltip title="UnBlocked">
                                <IconButton color="info" size="small">
                                  <LockResetIcon />
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}
                        {/* {(AccessID == "TR132" || AccessID == "TR354") && ( */}
                        {AccessID == "TR132" && (
                          <Link
                            to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                          >
                            <Tooltip title="Attachment">
                              <IconButton color="info" size="small">
                                <AttachFileIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        )}
                        {AccessID == "TR354" && (
                          <Link
                            to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                          >
                            <Tooltip title="Attachment">
                              <IconButton color="info" size="small">
                                <AttachFileIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        )}
                        {(AccessID == "TR132" || AccessID == "TR354") &&
                          params.row.TaskSource == "Sprint" && (
                            <Link>
                              <PDFButton
                                TaskSource={params.row.TaskSource}
                                DailytaskID={params.row.RecordID}
                                CompanyID={params.row.CompanyID}
                                AdditionallyBillable={
                                  params.row.AdditionalBillable
                                }
                                TaskStatus={params.row.Status}
                              />
                            </Link>
                          )}
                        {/* 
                    {AccessID == "TR132" || AccessID == "TR354" &&
                      (params.row.Status === "Assigned" ||
                        params.row.Status === "Scheduled") && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/P`}
                        >
                          <Tooltip title="Pick Now">
                            <IconButton color="info" size="small">
                              <DoneOutlineIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )} */}
                      </>
                    )}

                    {(AccessID == "TR263" || AccessID == "TR353") &&
                      params.row.Status != "Approved" &&
                      params.row.Status != "Dependence" &&
                      params.row.Transfer != -1 && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        >
                          <Tooltip title="Edit">
                            <IconButton color="info" size="small">
                              <ModeEditOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {/* {(AccessID == "TR263" || AccessID == "TR353") &&
                      params.row.Transfer == 0 &&
                      // params.row.AssignedBy == EMPID &&
                      (params.row.Status === "Blocked" ||
                        params.row.Status === "Assigned" ||
                        params.row.Status === "Inprogress" ||
                        params.row.Status === "Scheduled") && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/TO`}
                        >
                          <Tooltip title="Transfer">
                            <IconButton color="info" size="small">
                              <SwapHorizIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )} */}
                    {(AccessID == "TR263" || AccessID == "TR353") &&
                      // params.row.Transfer == 0 &&
                      // params.row.AssignedBy == EMPID &&
                      (params.row.TransfferedIcon === "Y") && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/TO`}
                        >
                          <Tooltip title="Transfer">
                            <IconButton color="info" size="small">
                              <SwapHorizIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}
                   

                    {(AccessID == "TR263" || AccessID == "TR353") &&
                      (params.row.Status == "Approved" ||
                        params.row.Status == "Transfer Out" ||
                        (params.row.Status == "Blocked" &&
                          params.row.Transfer != 0)) && (
                        <Link
                          to={`./Edit${screenName}/${params.row.RecordID}/V`}
                        >
                          <Tooltip title="View">
                            <IconButton color="info" size="small">
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      )}

                    {(AccessID == "TR263" || AccessID == "TR353") && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR266" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR266" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {/* //Homework_Listview */}
                    {AccessID == "TR365" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        state={{
                          AssignedDate: params.row.AssignedDate,
                          TargetedDate: params.row.TargetedDate,
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {/*                   
 {AccessID == "TR365" && (
                      <Link
                        to={`./EditEvaluation/${params.row.RecordID}/EV`}
                      >
                        <Tooltip title="Evaluation">
                          <IconButton color="info" size="small">
                            <CreditScoreIcon  />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )} */}

                    {AccessID == "TR160" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR160" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}


                    {AccessID == "TR208" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR208" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR242" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR242" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR216" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR216" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR219" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR219" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR086" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {AccessID == "TR086" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {/* {AccessID == "TR331" && (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <EventNoteIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )} */}
                    {AccessID == "TR331" && (
                      <Link
                        // to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        to={`/Apps/Secondarylistview/TR332/Payment/${params.row.RecordID}/${params.row.EmployeeID}`}
                        state={{
                          Employee: params.row.Employee,
                          Project: params.row.Project,
                          ProjectID: params.row.ProjectID,
                        }}
                      >
                        <Tooltip title="Payment">
                          <IconButton color="info" size="small">
                            <CurrencyRupeeOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {/* {AccessID == "TR332" && (
                      <Link
                         to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        // to={`/Apps/Secondarylistview/TR332/Payment/${params.row.RecordID}/${params.row.EmployeeID}`}
                        state={{
                          Employee: params.row.Employee,
                          Project: params.row.Project,
                          ProjectID: params.row.ProjectID,
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )} */}
                    {AccessID == "TR366" && (
                      <Link
                        // to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        to={`/Apps/Secondarylistview/TR332/Payment/${params.row.RecordID}/${params.row.EmployeeID}`}
                        state={{
                          Employee: params.row.Employee,
                          Project: params.row.Project,
                          ProjectID: params.row.ProjectID,
                        }}
                      >
                        <Tooltip title="Payment">
                          <IconButton color="info" size="small">
                            <CurrencyRupeeOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}

                    {AccessID == "TR262" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        state={{
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          MilestoneName: params.row.MilestoneName,
                          Activityname: params.row.ActivitesName,
                          TaskName: params.row.Name,
                          projectName: params.row.ProjectName,
                          stagesName: params.row.OperationStageName,
                        }}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}

                    {AccessID == "TR262" && (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/IM`}
                      >
                        <Tooltip title="Attachment">
                          <IconButton color="info" size="small">
                            <AttachFileIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                  </Box>
                );
              },
            };
          } else if (AccessID == "TR080") {
            listviewData.Data.columns.push(obj);
            dispatch(
              Success({
                requestId,
                columndata: listviewData.Data.columns,
                rowdata: listviewData.Data.rows,
              }),
            );
          } else if (
            AccessID !== "TR105" &&
            AccessID !== "TR102" &&
            AccessID !== "TR111" &&
            AccessID !== "TR112" &&
            AccessID !== "TR114" &&
            AccessID !== "TR115" &&
            AccessID !== "TR218" &&
            AccessID !== "TR394"
          ) {
            obj = {
              field: "action",
              headerName: "Action",
              minWidth: 250,
              headerAlign: "center",
              align: "center",
              filterable: false,
              sortable: false,
              disableColumnMenu: true,
              disableExport: true,
              renderCell: (params) => {
                const indentRecID = sessionStorage.getItem("indentRecID");

                return (
                  <Stack direction="row">
                    {AccessID !== "TR119" &&
                    AccessID !== "TR118" &&
                    AccessID !== "TR032" &&
                    AccessID !== "TR099" &&
                    AccessID !== "TR048" &&
                    AccessID !== "TR010" &&
                    AccessID !== "TR083" &&
                    AccessID !== "TR097" &&
                    AccessID !== "TR135" &&
                    AccessID !== "TR332" &&
                     AccessID !== "TR381" &&
                    AccessID !== "TR052" ? (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/E`}
                        state={
                          AccessID === "TR123"
                            ? {
                                EmpDTName: params.row.LocationName,
                              }
                            : AccessID === "TR132" || AccessID == "TR354"
                              ? {
                                  EmpDTName: params.row.LocationName,
                                  DTCheckinDate: params.row.CheckInDate,
                                }
                              : AccessID === "TR332"
                                ? {
                                    Employee: params.row.Employee,
                                    Project: params.row.Project,
                                    ProjectID: params.row.ProjectID,
                                  }
                                : AccessID === "TR134"
                                  ? {
                                      EmpDTName: params.row.LocationName,
                                      DTCheckinDate: params.row.CheckInDate,
                                    }
                                  : AccessID === "TR264"
                                    ? {
                                        EmpSpotActempID: params.row.EmpoyeeID,
                                      }
                                    : {
                                        CustomerID: params.row.CustomerRecordID,
                                        ProductID: params.row.ProductRecordID,
                                        BomID: params.row.BomRecordID,
                                      }
                        }
                        // state={{
                        //   CustomerID: params.row.CustomerRecordID,
                        //   ProductID: params.row.ProductRecordID,
                        //   BomID: params.row.BomRecordID,
                        // }}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR052" ? (
                      <Link
                        to={`./EditDelivery Chalan/${params.row.RecordID}/E`}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    

                      {AccessID === "TR381" && (
          <>
            {/* <Tooltip title="Edit">
              <IconButton
                color="info"
                size="small"
                onClick={() =>
                  navigate(`./Edit${screenName}/${params.row.RecordID}/E`, {
                    state: {
                      ...state,
                    },
                  })
                }
              >
                <ModeEditOutlinedIcon />
              </IconButton>
            </Tooltip> */}
            {params.row.Process === "P" ? (
              <PayslipBtn
                CompanyID={params.row.CompanyID}
                EmployeeID={params.row.EmployeeID}
                Finyear={params.row.Year}
                Month={params.row.Month}
              />
            ) : (
              <Tooltip title="Payslip Process pending">
                <IconButton color="error" sx={{ opacity: "0.5" }}>
                  <PictureAsPdfIcon />
                </IconButton>
              </Tooltip>
           )} 
          </>
        )}
                    {AccessID == "TR091" ? (
                      <Link
                        // to={"./price-of-other-customer"}
                        to={`./price-of-other-customer/${params.row.RecordID}`}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <AssessmentIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR099" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}`}
                      >
                        <Tooltip title="List of  usergroups">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR014" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}`}
                      >
                        <Tooltip title="Locations">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR123" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR132/ScrumTask/${params.row.RecordID}/${params.row.HiddenCheckinDate}`}
                        state={{
                          EmpDTName: params.row.LocationName,
                        }}
                      >
                        <Tooltip title="Scrum Task">
                          <IconButton color="info" size="small">
                            <TodayIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {/* {AccessID == "TR132" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR132/DailyTaskList/${EMPID}`}
                        state={{
                          EmpDTName: params.row.LocationName,
                        }}
                      >
                        <Tooltip title="Daily Task Icon">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )} */}
                    {/* {AccessID == "TR132" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR134/Daily Hour Task/${params.row.parentID}/${params.row.RecordID}/${params.row.CheckInDate}/${params.row.FuntionsName}/${params.row.ProjectName}`}
                        state={{
                          EmpDTName: params.row.LocationName,
                          DTCheckinDate: params.row.CheckInDate,
                        }}
                      >
                        <Tooltip title="Daily Hours Task ">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )} 

                    {AccessID == "TR136" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}/${params.row.RecordID}`}
                      >
                        <Tooltip title="Finance Entry">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR135" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.Type}`}
                      >
                        <Tooltip title="Fixed Asset Category">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR137" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}/${params.row.parentID}`}
                      >
                        <Tooltip title="Fixed Assets">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR128" ? (
                      <Box>
                        <Link
                          to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}/${params.row.parentID}`}
                        >
                          <Tooltip title="Gate">
                            <IconButton color="info" size="small">
                              <ListAltOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                        <Link
                          to={`/Apps/Secondarylistview/${params.row.ChildID1}/${params.row.ChildName1}/${params.row.RecordID}/${params.row.parentID}`}
                        >
                          <Tooltip title="Bin">
                            <IconButton color="info" size="small">
                              <ListAltOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </Box>
                    ) : (
                      false
                    )}

                    {/* http://skillglow.beyondexs.com/trinity/tcpdf/BOMCC.php?compID=3&PBBHID=99 */}
                    {AccessID == "TR083" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/Colors/${params.row.Type}`}
                      >
                        <Tooltip title="List of Colors">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}

                    {AccessID == "TR032" ? (
                      <Link to={`./Edit${screenName}/${params.row.RecordID}/E`}>
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {/* http://skillglow.beyondexs.com/trinity/tcpdf/BOMCC.php?compID=3&PBBHID=99 */}
                    {AccessID == "TR032" && params.row.MType === "L" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/Colors/${params.row.RecordID}/${params.row.Description}`}
                      >
                        <Tooltip title="List of Color shades">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR033" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/Colors-customer/${params.row.RecordID}/${params.row.parentName}/${params.row.Description}`}
                      >
                        <Tooltip title="List of Customer">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}

                    {AccessID == "TR097" ? (
                      <Link
                        to={`./${params.row.ChildID}/${params.row.RecordID}/DC/${params.row.Type}/${params.row.Description}/`}
                      >
                        <Tooltip title="List of Delivery Chalan">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR109" && params.row.Process == "Y" ? (
                      <Tooltip title="Print">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }Leatherpackingreport.php?Token=${
                            params.row.Hashtoken
                          }`}
                          target="_blank"
                          rel="noreferrer"
                          color="info"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {AccessID == "TR109" && params.row.Process == "Y" ? (
                      <IconButton
                        color="info"
                        size="small"
                        onClick={() => {
                          dispatch(
                            mailOpen({
                              row: params.row,
                              link: `${
                                store.getState().globalurl.pdfurl
                              }Leatherpackingreport.php?Token=${
                                params.row.Hashtoken
                              }`,
                            }),
                          );
                          dispatch(
                            getMail({
                              Templateid: "ET_011",
                              RecordID: params.row.RecordID,
                              UserName: "Trinity",
                            }),
                          );
                        }}
                      >
                        <EmailIcon />
                      </IconButton>
                    ) : null}
                    {AccessID == "TR050" && params.row.Process != "Y" ? (
                      <Link>
                        {" "}
                        <IconButton
                          color="primary"
                          variant="contained"
                          onClick={fnProcess(params.row.RecordID, "TR050")}
                          // onClick={()=>alert("hai")}
                        >
                          <SettingsBackupRestoreIcon />
                        </IconButton>
                      </Link>
                    ) : null}

                    {AccessID == "TR050" && params.row.Process == "Y" ? (
                      <Tooltip title="Cutting Component">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }BOMCC.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color="primary"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}

                    {AccessID == "TR050" && params.row.Process == "Y" ? (
                      <Tooltip title="Production">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }BOMPROD.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color="success"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}

                    {AccessID == "TR050" && params.row.Process == "Y" ? (
                      <Tooltip title="Packing">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }BOMPACK.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color="error"
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {AccessID == "TR050" && params.row.Process == "Y" ? (
                      <Tooltip title="All BOM">
                        <IconButton
                          component="a"
                          href={`${
                            store.getState().globalurl.pdfurl
                          }BOMALL.php?Token=${params.row.Hashtoken}`}
                          target="_blank"
                          rel="noreferrer"
                          color=""
                          size="small"
                        >
                          <PrintOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {AccessID == "TR050" && params.row.Process == "Y" ? (
                      <IconButton
                        color="info"
                        size="small"
                        onClick={() => {
                          dispatch(
                            mailOpen({
                              row: params.row,
                              link: `${
                                store.getState().globalurl.pdfurl
                              }BOMALL.php?Token=${params.row.Hashtoken}`,
                            }),
                          );
                          dispatch(
                            getMail({
                              Templateid: "ET_005",
                              RecordID: params.row.RecordID,
                              UserName: "Trinity",
                            }),
                          );
                        }}
                      >
                        <EmailIcon />
                      </IconButton>
                    ) : (
                      false
                    )}
                    {/* {AccessID == "TR087" ?
                 <IconButton component="a"  href={`${store.getState().globalurl.pdfurl}productpackinglist.php?`} target="_blank" 
                 rel="noreferrer"  color="info" size="small" ><PrintOutlinedIcon/>
                 </IconButton>
                :false} */}

                    {AccessID == "TR074" ? (
                      params.row.Complete == "N" ? (
                        <Box>
                          <Link
                            to={`./Editbatchissue/${params.row.RecordID}/E`}
                          >
                            <Tooltip title="Issue">
                              <IconButton color="info" size="small">
                                <ListAltOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>

                          <Link
                            to={`./Editbatchcompletion/${params.row.RecordID}/E`}
                          >
                            <Tooltip title="Completion">
                              <IconButton color="error" size="small">
                                <ListAltOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        </Box>
                      ) : (
                        <Box>
                          <Tooltip title="Batch Completed">
                            <IconButton color="success" size="small">
                              <CheckCircleOutlineIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )
                    ) : (
                      false
                    )}
                    {AccessID == "TR234" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR235/Task/${params.row.RecordID}`}
                        state={{
                          MilestoneID: params.row.MilestoneID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          stagesName: params.row.OperationStageName,
                          MilestoneName: params.row.MilestoneName,
                          Activityname: params.row.Name,
                        }}
                      >
                        <Tooltip title="Task">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}


                    {AccessID == "TR234" ? (
                      <Link
                        to={`/Apps/TR233/weightage/Editweightage/TK/${params.row.RecordID}/E`}
                        state={{
                          code: params.row.Code,
                          Desc: params.row.Name,
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          stagesName: params.row.OperationStageName,
                          MilestoneName: params.row.MilestoneName,
                          Activityname: params.row.Name,
                        }}
                      >
                        <Tooltip title="Task Weightage">
                          <IconButton color="info" size="small">
                            <BalanceIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR332" ? (
                      <>
                        {/* EDIT */}
                        <Link
                          // to={`/Apps/Secondarylistview/TR332/Payment/135/320/EditPayment/${params.row.RecordID}/E`}
                          to={`./EditPayment/${params.row.RecordID}/E`}
                          // to={`./EditIssue/${params.row.RecordID}/${params.row.MaterialDescription}/${params.row.ItemType}/${params.row.HeaderQty}/E`}

                          state={{
                            code: params.row.Code,
                            Desc: params.row.Name,
                            MilestoneID: params.row.RecordID,
                            projectID: params.row.ProjectID,
                            OperationStageID: params.row.OperationStageID,
                            projectName: params.row.Project,
                            Employee: params.row.Employee,
                          }}
                        >
                          <Tooltip title="Edit">
                            <IconButton color="info" size="small">
                              <ModeEditOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>

                        {/* PDF */}
                        <Tooltip title="Download Receipt">
                          <span>
                            <PDFDownloadLink
                              document={
                                // <ReceiptPDF2
                                //   data={{
                                //     invoiceNo: params.row?.RecordID,
                                //     Employee: params.row?.Employee,
                                //     total: "500",
                                //     PaymentMode: params.row?.PaymentMode,
                                //     PaidAmount: params.row?.PaidAmount,
                                //     PaymentReference: params.row?.PaymentRefereance,
                                //     DueAmount: params.row?.DueAmount,
                                //   }}
                                // />
                                <ReceiptPDF2
                                  data={{
                                    Employee: params.row?.ReceiverName,
                                    PaymentMode: params.row?.PaymentMode,
                                    InvoiceNo: params.row?.InvoiceNo,
                                    InvoiceAmount: params.row?.InvoiceAmount,
                                    PreviouslyPaid: params.row?.PreviouslyPaid,
                                    MobileNo: params.row?.ReceiverMobileNo,
                                    EmailID: params.row?.ReceiverEmailID,
                                    Address: params.row?.ReceiverAddress,
                                    CompanyName: params.row?.CompanyName,
                                    paymentDetails: [
                                      {
                                        sno: 1,
                                        PaymentReference:
                                          params.row?.PaymentRefereance,
                                        PaidAmount: params.row?.PaidAmount,
                                        DueAmount: params.row?.Due,
                                      },
                                    ],
                                  }}
                                  filters={{
                                    Imageurl: baseurl1,
                                    HeaderImg:
                                      sessionStorage.getItem("HeaderImg"),
                                    FooterImg:
                                      sessionStorage.getItem("FooterImg"),
                                    CompanySignature:
                                      sessionStorage.getItem(
                                        "CompanySignature",
                                      ),
                                  }}
                                />
                              }
                              fileName={`Receipt.pdf`}
                            >
                              {({ loading }) =>
                                loading ? (
                                  <IconButton size="small">
                                    <CircularProgress size={18} />
                                  </IconButton>
                                ) : (
                                  <IconButton size="small">
                                    <PictureAsPdfIcon color="error" />
                                  </IconButton>
                                )
                              }
                            </PDFDownloadLink>
                          </span>
                        </Tooltip>
                      </>
                    ) : null}
                    {/* {AccessID == "TR133" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR233/Milestones/${params.row.RecordID}`}
                        state={{
                          code: params.row.Code,
                          Desc: params.row.Name,
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          projectName: params.row.Name,
                        }}
                      >
                        <Tooltip title="Milestone">
                          <IconButton color="info" size="small">
                            <FlagIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR133" ? (
                      <Link
                        to={`/Apps/TR233/weightage/Editweightage/M/${params.row.RecordID}/E`}
                        state={{
                          code: params.row.Code,
                          Desc: params.row.Name,
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          projectName: params.row.Name,
                        }}
                      >
                        <Tooltip title="Milestone Weightage">
                          <IconButton color="info" size="small">
                            <BalanceIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR133" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR262/Sprint/${params.row.RecordID}`}
                        state={{
                          code: params.row.Code,
                          Desc: params.row.Name,
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          projectName: params.row.Name,
                        }}
                      >
                        <Tooltip title="Sprint">
                          <IconButton color="info" size="small">
                            <TaskAltIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR133" ? (
                      <Link
                        to={`/Apps/Role/EditRole/M/${params.row.RecordID}/E`}
                        state={{
                          code: params.row.Code,
                          Desc: params.row.Name,
                          MilestoneID: params.row.RecordID,
                          projectID: params.row.ProjectID,
                          OperationStageID: params.row.OperationStageID,
                          projectName: params.row.Name,
                        }}
                      >
                        <Tooltip title="Role">
                          <IconButton color="info" size="small">
                            <PeopleAltIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )} */}
                    {AccessID == "TR074" ? (
                      params.row.parentID == "CC" &&
                      params.row.Process == "Y" ? (
                        <Tooltip title="Print ">
                          <IconButton
                            component="a"
                            href={`${
                              store.getState().globalurl.pdfurl
                            }BATCHCC.php?Token=${params.row.Hashtoken}`}
                            target="_blank"
                            rel="noreferrer"
                            color="info"
                            size="small"
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}
                    {AccessID == "TR074" ? (
                      params.row.parentID == "PC" &&
                      params.row.Process == "Y" ? (
                        <Tooltip title="Print">
                          <IconButton
                            component="a"
                            href={`${
                              store.getState().globalurl.pdfurl
                            }BATCHPROD.php?Token=${params.row.Hashtoken}`}
                            target="_blank"
                            rel="noreferrer"
                            color="info"
                            size="small"
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}
                    {AccessID == "TR074" ? (
                      params.row.parentID == "PK" &&
                      params.row.Process == "Y" ? (
                        <Tooltip title="Print">
                          <IconButton
                            component="a"
                            href={`${
                              store.getState().globalurl.pdfurl
                            }BATCHPACK.php?Token=${params.row.Hashtoken}`}
                            target="_blank"
                            rel="noreferrer"
                            color="info"
                            size="small"
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}
                    {AccessID == "TR074" &&
                    params.row.parentID == "CC" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }BATCHCC.php?Token=${params.row.Hashtoken}`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_013",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR074" &&
                    params.row.parentID == "PC" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }BATCHPROD.php?Token=${params.row.Hashtoken}`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_014",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR074" &&
                    params.row.parentID == "PK" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }BATCHPACK.php?Token=${params.row.Hashtoken}`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_015",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR048" ? (
                      <Box>
                        <Link
                          to={`./EditIssue/${params.row.RecordID}/${params.row.MaterialDescription}/${params.row.ItemType}/${params.row.HeaderQty}/E`}
                        >
                          <Tooltip title="Issue">
                            <IconButton color="info" size="small">
                              <SummarizeOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                        {/* <Link
                       to={`./EditIssue/${params.row.RecordID}/${params.row.MaterialDescription}/${params.row.ItemType}/${params.row.HeaderQty}/E`}
                     > */}
                        <Tooltip title="Material">
                          {/* //here change */}
                          <IconButton
                            onClick={() =>
                              dispatch(
                                productionlookupOpen({
                                  materialRecID: params.row.MtlRecordID,
                                }),
                              )
                            }
                            color="info"
                            size="small"
                          >
                            <OpenInBrowserOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                        {/* </Link> */}
                      </Box>
                    ) : (
                      false
                    )}

                    {/* {AccessID == "TR048" ?
        
                    
                   params.row.Type =="M"?
                    <Tooltip title="Indent">
                    <IconButton color="info" size="small"  onClick={()=>dispatch(PurchaseIndent({RecordID:params.row.RecordID}))}>
                       <ReceiptLongIcon />
                    </IconButton>
                  </Tooltip>
                  :false

                 
                :false} */}
                    {/* INDENT ITEM --- PRODUCTION CARD */}
                    {AccessID == "TR118" ? (
                      <Link
                        to={`./${params.row.ChildID}/${params.row.ChildName}/PC/${params.row.RecordID}/${params.row.Type}`}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR119" ? (
                      <Tooltip title="Indent Order">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={indentOrderSave(
                            "insert",
                            indentRecID,
                            params.row.SupplierID,
                            params.row.parentID,
                          )}
                        >
                          <ListAltOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {AccessID == "TR003" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR004/List%20of%20Materials/${params.row.RecordID}/${params.row.parentID}/${params.row.Name}/${params.row.SearchPhrase}/pm`}
                      >
                        <Tooltip title="Material">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR001" ? (
                      <Link
                        to={`/Apps/Secondarylistview/TR050/List of BOM/${params.row.RecordID}/${params.row.ProductDescription}/${params.row.Description}/all-bom/${params.row.parentID}`}
                      >
                        <Tooltip title="List of BOM">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}

                    {/* {AccessID == "TR079" ?
                     <Link to={`/Apps/Secondarylistview/TR080/Material Master/${params.row.RecordID}`}>
                     <Tooltip title="Material Master">
                       <IconButton color="info" size="small">
                         <ReceiptLongIcon />
                       </IconButton>
                     </Tooltip>
                 </Link>
                :false} */}
                    {AccessID == "TR001" ? (
                      <Link
                        to={`/Apps/TR069/Editproductstock/${params.row.RecordID}/${params.row.ModelCode}/${params.row.Description}/E`}
                      >
                        <Tooltip title="Stock">
                          <IconButton color="error" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR004" ? (
                      params.row.STKType != "S" ? (
                        <Link to={`./Editstock/${params.row.RecordID}/E`}>
                          <Tooltip title="Stock">
                            <IconButton color="info" size="small">
                              <ListAltOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}
                    {/* {AccessID == "TR048" ?
                       <Link to={`./EditIssue/${params.row.RecordID}/${params.row.MaterialDescription}/${params.row.ItemType}/${params.row.HeaderQty}/E`}>
                     <Tooltip title="Issue">
                       <IconButton color="info" size="small">
                         <SummarizeOutlinedIcon />
                       </IconButton>
                     </Tooltip>
                 </Link>
                :false} */}
                    {AccessID == "TR002" ? (
                      <Link
                        to={`/Apps/Secondarylistview/${params.row.ChildID}/${params.row.ChildName}/${params.row.RecordID}/${params.row.Name}`}
                      >
                        <Tooltip title="Products">
                          <IconButton color="info" size="small">
                            <ListAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR010" ? (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/E/${0}`}
                      >
                        <Tooltip title="Edit">
                          <IconButton color="info" size="small">
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}

                    {AccessID == "TR010" ? (
                      <Link
                        to={`./Edit${screenName}/${params.row.RecordID}/E/${2}`}
                      >
                        <Tooltip title="Customer Products">
                          <IconButton color="info" size="small">
                            <WysiwygIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}
                    {AccessID == "TR010" ? (
                      <Link
                        to={`/Apps/TR400/Editcustomerlinechart/EditCustomer Line Chart/${params.row.RecordID}/E`}
                      >
                        <Tooltip title="Customer Analysis">
                          <IconButton color="info" size="small">
                            <AssessmentIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : (
                      false
                    )}

                    {/* {AccessID == "TR011" ?
                   <Link to={`/Apps/product-analysis/${params.row.CustRecordID}/E`}>
                   <Tooltip title="Customer Analysis">
                     <IconButton color="info" size="small"  >
                       <AssessmentIcon />
                     </IconButton>
                   </Tooltip>
                 </Link>
                :false} */}
                    {AccessID == "TR011" ? (
                      params.row.Process == "Y" ? (
                        params.row.InvType == "SI" ? (
                          <Tooltip title="Print">
                            <IconButton
                              component="a"
                              href={`${
                                store.getState().globalurl.pdfurl
                              }sampleinvoice.php?Token=${params.row.Hashtoken}`}
                              target="_blank"
                              rel="noreferrer"
                              color="info"
                              size="small"
                            >
                              <PrintOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : params.row.InvType == "FI" &&
                          params.row.parentID == "P" ? (
                          <Tooltip title="Print">
                            <IconButton
                              component="a"
                              href={`${
                                store.getState().globalurl.pdfurl
                              }finalreport.php?Token=${params.row.Hashtoken}`}
                              target="_blank"
                              rel="noreferrer"
                              color="info"
                              size="small"
                            >
                              <PrintOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : params.row.parentID == "L" &&
                          params.row.InvType == "FI" &&
                          params.row.Process == "Y" ? (
                          <Tooltip title="Print">
                            <IconButton
                              component="a"
                              href={`${
                                store.getState().globalurl.pdfurl
                              }leatherinvoice.php?Token=${
                                params.row.Hashtoken
                              }`}
                              target="_blank"
                              rel="noreferrer"
                              color="info"
                              size="small"
                            >
                              <PrintOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Print">
                            <IconButton
                              component="a"
                              href={`${
                                store.getState().globalurl.pdfurl
                              }report.php?Token=${params.row.Hashtoken}`}
                              target="_blank"
                              rel="noreferrer"
                              color="info"
                              size="small"
                            >
                              <PrintOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        )
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}

                    {AccessID == "TR011" &&
                    params.row.InvType == "PI" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }report.php?Token=${params.row.Hashtoken}
                              }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_001",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR011" &&
                    params.row.InvType == "SI" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }sampleinvoice.php?Token=${params.row.Hashtoken}
                              }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_003",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR011" &&
                    params.row.parentID == "P" &&
                    params.row.InvType == "FI" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }report.php?Token=${params.row.Hashtoken}
                              }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_002",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR011" &&
                    params.row.parentID == "L" &&
                    params.row.InvType == "FI" &&
                    params.row.Process == "Y" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }leatherinvoice.php?Token=${
                                  params.row.Hashtoken
                                }
                              }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_012",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    {AccessID == "TR084" ? (
                      params.row.Process == "Y" &&
                      params.row.parentID == "PL" ? (
                        <Tooltip title="Print">
                          <IconButton
                            component="a"
                            href={`${
                              store.getState().globalurl.pdfurl
                            }domesticinvoice.php?Token=${params.row.Hashtoken}`}
                            target="_blank"
                            rel="noreferrer"
                            color="info"
                            size="small"
                            download={true}
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : params.row.Process == "Y" &&
                        params.row.parentID == "LL" ? (
                        <Tooltip title="Print">
                          <IconButton
                            component="a"
                            href={`${
                              store.getState().globalurl.pdfurl
                            }leatherdomesticinvoice.php?Token=${
                              params.row.Hashtoken
                            }`}
                            target="_blank"
                            rel="noreferrer"
                            color="info"
                            size="small"
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        false
                      )
                    ) : (
                      false
                    )}
                    {AccessID == "TR084" &&
                    params.row.Process == "Y" &&
                    params.row.parentID == "PL" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }domesticinvoice.php?Token=${
                                  params.row.Hashtoken
                                }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_004",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {AccessID == "TR084" &&
                    params.row.Process == "Y" &&
                    params.row.parentID == "LL" ? (
                      <Tooltip title="Email">
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {
                            dispatch(
                              mailOpen({
                                row: params.row,
                                link: `${
                                  store.getState().globalurl.pdfurl
                                }leatherdomesticinvoice.php?Token=${
                                  params.row.Hashtoken
                                }`,
                              }),
                            );
                            dispatch(
                              getMail({
                                Templateid: "ET_004",
                                RecordID: params.row.RecordID,
                                UserName: "Trinity",
                              }),
                            );
                          }}
                        >
                          <EmailIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    {params.row.ImgApp == "Y" ? (
                      AccessID == "TR002" ? (
                        <Link
                          to={`/Apps/${screenName}/imageupload/${AccessID}/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : AccessID == "TR009" ? (
                        <Link
                          to={`/Apps/${screenName}/imageupload/${AccessID}/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : AccessID == "TR010" ? (
                        <Link
                          to={`/Apps/${screenName}/imageupload/${AccessID}/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : AccessID == "TR027" ? (
                        <Box>
                          <Link
                            to={`/Apps/${screenName}/imageupload/${AccessID}/${params.row.RecordID}`}
                          >
                            <Tooltip title="Image upload">
                              <IconButton color="info" size="small">
                                <AddPhotoAlternateIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                          <Link
                            to={`/Apps/Secondarylistview/TR123/Check In/${params.row.RecordID}`}
                          >
                            <Tooltip title="Check In">
                              <IconButton color="info" size="small">
                                <ListAltOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                          <Link
                            to={`/Apps/Secondarylistview/TR124/Check Out/${params.row.RecordID}`}
                          >
                            <Tooltip title="Check Out">
                              <IconButton color="info" size="small">
                                <ListAltOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                          <Link
                            to={`/Apps/TR027/Employees/EditEmpfinance entry/E/${params.row.RecordID}/${params.row.Name}`}
                          >
                            <Tooltip title="Finance Entry">
                              <IconButton color="info" size="small">
                                <ListAltOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        </Box>
                      ) : AccessID == "TR003" ? (
                        <Link
                          to={`/Apps/Secondarylistview/${AccessID}/${screenName}/${params.row.parentID}/EditMaterial Category/imageupload/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : AccessID == "TR004" ? (
                        <Link
                          to={`/Apps/Secondarylistview/${AccessID}/${screenName}/${params.row.parentID}/${params.row.Type}/${params.row.parentName}/${params.row.SearchPhrase}/imageupload/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : AccessID == "TR001" ? (
                        <Link
                          to={`/Apps/Secondarylistview/${AccessID}/${screenName}/${params.row.parentID}/${params.row.ProductDescription}/imageupload/${params.row.RecordID}`}
                        >
                          <Tooltip title="Image upload">
                            <IconButton color="info" size="small">
                              <AddPhotoAlternateIcon />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      ) : (
                        false
                      )
                    ) : (
                      ""
                    )}
                  </Stack>
                );
              },
            };
          }


          if (AccessID == "TR047") {
            const obj = {
              field: "Status",
              headerName: "",
              headerAlign: "center",
              sortable: false,
              filterable: false,
              disableColumnMenu: true,
              minWidth: 100,
              maxWidth: 100,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Stack direction="row">
                    {params.row.Startdate == "" ? (
                      <Link>
                        <Tooltip title="Not yet Started">
                          <IconButton color="success">
                            <PlayCircleOutlineOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    ) : params.row.Startdate != "" &&
                      params.row.Completeddate == "" ? (
                      <Box>
                        {params.row.Pausedate == "" ? (
                          <Link>
                            <Tooltip
                              title={params.row.Pausedate || "Inprogress"}
                            >
                              <IconButton color="primary">
                                <NotStartedOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : params.row.ContinueDate == "" ? (
                          <Link>
                            <Tooltip title="Inprogress">
                              <IconButton color="primary">
                                <NotStartedOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        ) : (
                          false
                        )}
                        <Link>
                          {/* <Tooltip title={params.row.Completeddate || "Complete"}>
            <IconButton color="success" onClick={productionCardUPdate("C",params.row.RecordID)}>
              <TaskAltOutlinedIcon/>
              </IconButton>
              </Tooltip> */}
                        </Link>
                      </Box>
                    ) : (
                      <Link>
                        <Tooltip title="Completed">
                          <IconButton color="success">
                            <TaskAltOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                  </Stack>
                );
              },
            };
            listviewData.Data.columns.splice(2, 0, obj);
          }

          if (AccessID == "TR132" || AccessID == "TR354") {
            const obj = {
              field: "Type",
              headerName: "",
              headerAlign: "center",
              sortable: false,
              filterable: false,
              disableColumnMenu: true,
              minWidth: 50,
              maxWidth: 50,
              disableExport: true,
              renderCell: (params) => {
                return (
                  <Stack direction="row">
                    <Link>
                      {params.row.Transfer == 1 &&
                      params.row.Status === "Assigned" ? (
                        <Tooltip title="Transfer In">
                          <IconButton color="info">
                            <UndoIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        false
                      )}
                    </Link>
                    <Link>
                      {params.row.Transfer == -1 &&
                        params.row.Status === "Blocked" && (
                          <Tooltip title="Transfer Out">
                            <IconButton color="warning">
                              <RedoIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                    </Link>
                  </Stack>
                );
              },
            };
            listviewData.Data.columns.splice(2, 0, obj);
          }

          listviewData.Data.columns.push(obj);

          dispatch(
            Success({
              requestId,
              columndata: listviewData.Data.columns,
              rowdata: listviewData.Data.rows,
            }),
          );
        } else {
          dispatch(Success({ requestId, columndata: [], rowdata: [] }));
        }
      })

      .catch((error) => {
        dispatch(errored(requestId, error.message));
      });
  };
const EmployeeAction = ({ params, accessID }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  console.log(state, "--Listviewapireducers state");
  const dispatch = useDispatch();
  const EMPID = sessionStorage.getItem("EmpId");
  const CompId = sessionStorage.getItem("companyId");
  console.log("🚀 ~ EmployeeAction ~ CompId:", CompId);
  // const fnLeaveApproval = async (data) => {
  //   const res = await dispatch(leaveAppoval({ data }));

  //   // if (res.payload.status == 200) {
  //   if (res.payload.Status == "Y") {
  //     toast.success(res.payload.Msg);
  //     dispatch(
  //       fetchListview(
  //         accessID,
  //         "approval",
  //         accessID == "TR245"
  //           ? `EmployeeID='${data.EmployeeID}'`
  //           : // ? `CompanyID ='${CompId}' AND EmployeeID='${data.EmployeeID}'`
  //           accessID == "TR255"
  //           ? `CompanyID ='${CompId}' AND Approvedby='${data.EmployeeID}'`
  //           : accessID == "TR256"
  //           ? `EmployeeID='${data.EmployeeID}'`
  //           : accessID == "TR254"
  //           ? `EmployeeID='${data.EmployeeID}'`
  //           : accessID == "TR246"
  //           ? `CompanyID ='${CompId}' AND parentID ='${data.EmployeeID}'`
  //           : accessID == "TR267"
  //           ? `EmployeeID='${data.EmployeeID}'`
  //           : accessID == "TR248"
  //           ? `LA_APPEMID ='${EMPID}' ) AND parentID='${data.EmployeeID}' AND CompanyID ='${CompId}'`
  //           : accessID == "TR247"
  //           ? `CompanyID ='${CompId}' AND parentID ='${data.EmployeeID}'`
  //           : `EmployeeID='${data.EmployeeID}'`,

  //             // `${data.EmployeeID}`
  //       )
  //     );
  //     dispatch(mailNotify(data));
  //   } else {
  //     toast.error(res.payload.Msg);
  //   }

  //   console.log("🚀 ~ fnLeaveApproval ~ res:", res);
  // };
  const fnLeaveApproval = async (data) => {
    const res = await dispatch(leaveAppoval({ data }));

    // if (res.payload.status == 200) {
    if (res.payload.Status == "Y") {
      toast.success(res.payload.Msg);
      dispatch(
        fetchListview(
          accessID,
          "approval",
          accessID == "TR245"
            ? // ? `EmployeeID='${data.EmployeeID}'`
              `CompanyID ='${CompId}' AND EmployeeID='${data.EmployeeID}'`
            : accessID == "TR255"
              ? `CompanyID='${CompId}' AND Approvedby='${data.EmployeeID}'`
              : accessID == "TR256"
                ? `CompanyID='${CompId}' AND EmployeeID='${data.EmployeeID}'`
                : accessID == "TR254"
                  ? `CompanyID='${CompId}' AND EmployeeID='${data.EmployeeID}'`
                  : accessID == "TR246"
                    ? `CompanyID='${CompId}' AND parentID='${data.EmployeeID}'`
                    : accessID == "TR267"
                      ? `CompanyID='${CompId}' AND EmployeeID='${data.EmployeeID}'`
                      : accessID == "TR248"
                        ? // ? `LA_APPEMID='${EMPID}' ) AND parentID='${data.EmployeeID}' AND CompanyID='${CompId}'`
                          `LA_APPEMID='${EMPID}' AND parentID='${data.EmployeeID}' AND CompanyID='${CompId}'`
                        : accessID == "TR247"
                          ? `CompanyID='${CompId}' AND parentID='${data.EmployeeID}'`
                          : `EmployeeID='${data.EmployeeID}'`,

          // `${data.EmployeeID}`
        ),
      );
      dispatch(mailNotify(data));
    } else {
      toast.error(res.payload.Msg);
    }

    console.log("🚀 ~ fnLeaveApproval ~ res:", res);
  };
  return (
    <Fragment>
      <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
        {/* Permission Icon */}
        {(accessID === "TR245" && params.row.Permission == "Y") ? (
          <Tooltip title="Permission">
            <IconButton
              color={params.row.PermissionStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR267/Permission/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <CoPresentIcon />
            </IconButton>
          </Tooltip>
        ) : null}

        {/* Permission to Nested Icons */}
        {accessID === "TR267" && params.row.Status == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR266/permission-approval/${params.row.EmployeeID}/manager/EditPermission-approval/${params.row.RecordID}/M`}
              state={{
                parentID: params.parentID,
                // EmpLeaveAppName: params.row.
                // EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty
              }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR267" && params.row.Status == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "P",
                    Status: "Y",
                    Reason: "",
                    ManagerID: EMPID,
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "P",
                    Status: "N",
                    Reason: "",
                    ManagerID: EMPID,
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR267" && params.row.Status != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.EmployeeID,
                      Type: "P",
                      Status: "AL",
                      ManagerID: EMPID,
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}
        {/* Leave */}
        {accessID === "TR248" &&
        (params.row.ELStatus == "Applied" ||
          params.row.ELStatus == "Partially Approved" ||
          params.row.ELStatus == "Re-Apply") ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR208/leave-approval/${params.row.parentID}/manager/Editleaveapproval/${params.row.RecordID}/M`}
              // state={{
              //   EmpLeaveAppName: params.row.
              //   EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty

              // }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR248" &&
        (params.row.ELStatus == "Applied" ||
          params.row.ELStatus == "Partially Approved" ||
          params.row.ELStatus == "Re-Apply") ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.parentID,
                    Type: "L",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.parentID,
                    Type: "L",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR248" &&
        params.row.ELStatus != "Applied" &&
        params.row.ELStatus != "Partially Approved" &&
        params.row.ELStatus != "Re-Apply" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.parentID,
                      Type: "L",
                      Status: "AL",
                      ManagerID: EMPID,
                      Source: "M",
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {(accessID === "TR245" && params.row.ELeave == "Y") ? (
          <Tooltip title="Leave">
            <IconButton
              color={params.row.LeaveStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR248/leave-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <FollowTheSignsOutlinedIcon />
            </IconButton>
          </Tooltip>
        ) : // ) : (
        //   <div></div>
        // )}
        null}

        {accessID === "TR246" && params.row.OndutyStatus == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR242/onduty-approval/${params.row.parentID}/manager/Editondutyapproval/${params.row.RecordID}/M`}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR246" && params.row.OndutyStatus == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.parentID,
                    Type: "OD",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.parentID,
                    Type: "OD",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR246" && params.row.OndutyStatus != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"OD","Status":"AL"} )
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.parentID,
                      Type: "OD",
                      Status: "AL",
                      ManagerID: EMPID,
                      Source: "M",
                    }),
                  );
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {(accessID === "TR245" && params.row.Onduty == "Y") ? (
          <Tooltip title="On Duty">
            <IconButton
              color={params.row.OndutyStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR246/onduty-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <WorkOutlinedIcon />
            </IconButton>
          </Tooltip>
        ) : (
          false
        )}

        {accessID === "TR247" && params.row.EStatus == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR216/overtime-approval/${params.row.parentID}/manager/Editovertimeapproval/${params.row.RecordID}/M`}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR247" && params.row.EStatus == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    EmployeeID: params.row.parentID,
                    Type: "OT",
                    Status: "Y",
                    Reason: "",
                    ManagerID: EMPID,
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    EmployeeID: params.row.parentID,
                    Type: "OT",
                    Status: "N",
                    Reason: "",
                    ManagerID: EMPID,
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR247" && params.row.EStatus != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"OT","Status":"AL"} )
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.parentID,
                      Type: "OT",
                      Status: "AL",
                      ManagerID: EMPID,
                      Source: "M",
                    }),
                  );
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {(accessID === "TR245" && params.row.OverTime == "Y") ? (
          <Tooltip title="Overtime">
            <IconButton
              color={params.row.OverTimeStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR247/overtime-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <MoreTimeOutlinedIcon />
            </IconButton>
          </Tooltip>
        ) : (
          false
        )}

        {/* Regularization */}
        {(accessID === "TR245" && params.row.Regularization == "Y") ? (
          <Tooltip title="Regularization">
            <IconButton
              color={
                params.row.RegularizationStatus == "Y" ? "warning" : "info"
              }
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR256/regularization-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <AttributionIcon />
            </IconButton>
          </Tooltip>
        ) : null}

        {/* Regularization to Nested Icons */}
        {accessID === "TR256" && params.row.AppliedStatus == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR219/leave-approval/${params.row.EmployeeID}/manager/Editregularization-approval/${params.row.RecordID}/M`}
              // state={{
              //   EmpLeaveAppName: params.row.
              //   EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty

              // }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR256" && params.row.AppliedStatus == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "RG",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "RG",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR256" && params.row.AppliedStatus != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.EmployeeID,
                      Type: "RG",
                      Status: "AL",
                      ManagerID: EMPID,
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}
        {/* Expense */}
        {(accessID === "TR245" && params.row.ExpensesEntry == "Y") ? (
          <Tooltip title="Expense">
            <IconButton
              color={params.row.ExpensesEntryStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR255/expense-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <ExplicitIcon />
            </IconButton>
          </Tooltip>
        ) : null}

        {/* Expense to Nested Icons */}
        {accessID === "TR255" && params.row.Status == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR086/leave-approval/${params.row.Approvedby}/manager/Editfinanceapproval/${params.row.RecordID}/M`}
              // state={{
              //   EmpLeaveAppName: params.row.
              //   EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty

              // }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR255" && params.row.Status == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.Approvedby,
                    Type: "EE",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.Approvedby,
                    Type: "EE",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR255" && params.row.Status != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.Approvedby,
                      Type: "EE",
                      Status: "AL",
                      ManagerID: EMPID,
                      Source: "M",
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {/* Salary Advance */}

        {(accessID === "TR245" && params.row.SalaryAdvance == "Y") ? (
          <Tooltip title="Salary Advance">
            <IconButton
              color={params.row.SalaryAdvanceStatus == "Y" ? "warning" : "info"}
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR254/salary-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <RequestQuoteOutlinedIcon />
            </IconButton>
          </Tooltip>
        ) : null}

        {/* Salary Advance to Nested Icons */}
        {accessID === "TR254" && params.row.Status == "Applied" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR160/leave-approval/${params.row.EmployeeID}/manager/EditSalary Advanceapproval/${params.row.RecordID}/M`}
              state={{
                parentID: params.parentID,
                // EmpLeaveAppName: params.row.
                // EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty
              }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR254" && params.row.Status == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "SA",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "SA",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR254" && params.row.Status != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.EmployeeID,
                      Type: "SA",
                      Status: "AL",
                      ManagerID: EMPID,
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {/* Query Approval  */}
        {/* {accessID === "TR245" ? (
          <Tooltip title="Query">
            <IconButton
              color= "info"
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR272/Query-approval/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  }
                )
              }
            >
              <ContactSupportIcon />
            </IconButton>
          </Tooltip>
        ) : null} */}
        {/* Query Approval to Nested Icons */}
        {/* {accessID === "TR272" && params.row.Status == "Applied" ? ( */}
        {accessID === "TR272" ? (
          <Fragment>
            <Link
              to={`/Apps/Secondarylistview/TR271/query-approval/${params.row.EmployeeID}/manager/EditQuery-approval/${params.row.RecordID}/M`}
              state={{
                parentID: params.parentID,
                // EmpLeaveAppName: params.row.
                // EmpLeaveOTOnduty: params.row.EmpLeaveOTOnduty
              }}
            >
              <Tooltip title="Edit">
                <IconButton color="info" size="small">
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Link>
          </Fragment>
        ) : (
          false
        )}
        {accessID === "TR272" && params.row.Status == "Applied" ? (
          <Fragment>
            <Tooltip title="Approve">
              <IconButton
                color="success"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "QR",
                    Status: "Y",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                color="error"
                size="small"
                onClick={() =>
                  fnLeaveApproval({
                    RecordID: params.row.RecordID,
                    ManagerID: EMPID,
                    EmployeeID: params.row.EmployeeID,
                    Type: "QR",
                    Status: "N",
                    Reason: "",
                    Source: "M",
                  })
                }
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {accessID === "TR272" && params.row.Status != "Applied" ? (
          <Fragment>
            <Tooltip title="Review">
              <IconButton
                color="success"
                size="small"
                onClick={() => {
                  dispatch(
                    isReasonOpen({
                      RecordID: params.row.RecordID,
                      EmployeeID: params.row.EmployeeID,
                      Type: "QR",
                      Status: "AL",
                      ManagerID: EMPID,
                    }),
                  );
                  // fnLeaveApproval({"RecordID":params.row.RecordID,"EmployeeID":params.row.parentID,"Type":"L","Status":"AL"} )
                }}
              >
                <LockOpenIcon />
              </IconButton>
            </Tooltip>
          </Fragment>
        ) : (
          false
        )}

        {/* Employee */}

        {accessID === "TR245" ? (
          <Tooltip title="Personnel">
            <IconButton
              color="info"
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/TR245/Employees/${params.row.RecordID}`,
                  {
                    state: {
                      EmpLeaveOTOnduty: params.row.Name,
                    },
                  },
                )
              }
            >
              <GroupsIcon />
            </IconButton>
          </Tooltip>
        ) : (
         false
        )}
      </div>
    </Fragment>
  );
};
const AssessmentAction = ({ params, accessID, screenName, rights }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const dispatch = useDispatch();
  const EMPID = sessionStorage.getItem("EmpId");
  const { BreadCrumb1 } = location.state || {};
  const ManagerEmpIDCS = sessionStorage.getItem("ManagerEmpIDCS");
  const EMP_TRAINBY = sessionStorage.getItem("EMP_TRAINBY");

  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const CompanySignature = sessionStorage.getItem("CompanySignature");
  const [footerHeight, setFooterHeight] = useState(60);
  const CompId = sessionStorage.getItem("companyId");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const sliceSubscriptionCode = SubscriptionCode.slice(-3);
  const FnAssessmentCheck = async (row) => {
    const data = await dispatch(
      AssessmentCheck({
        data: {
          EmpassscheduledRecordID: row.RecordID,
          EmployeeID: row.EmployeeID,
        },
      }),
    );

    if (data.payload.Status == "Y") {
      const result = await Swal.fire({
        title: "Do you want to attend this assessment?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        navigate(`./Edit${screenName}/${row.AssessmentID}/${row.RecordID}/A`, {
          state: {
            ...state,
            BreadCrumb1,
            BreadCrumb2: row.AssessmentName,
            BreadCrumb3: row.QuestionGroupName,
          },
        });
      }
    } else {
      Swal.fire({
        title: data.payload.Msg,
        // text: data.payload.Msg,
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      //toast.error(data.payload.Msg);
    }

    // if(data.payload.)
  };

  const InprogressCheck = () => {
    Swal.fire({
      title: "Appraisal Process Inprogress",
      text: "This assessment has not been completed by others.",
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    });
  };

  const handleTermsProcess = async (values) => {
    const result = await Swal.fire({
      title:
        "If you process this Timetable you will not able to edit. Do you want to proceed?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      const data = await dispatch(
        TimetableProcessController({
          data: {
            HeaderID: values.RecordID,
            TeacherID: EMPID,
            Process: "Y",
          },
        }),
      );

      if (data.payload.Status === "Y") {
        Swal.fire({
          title: data.payload.Message,
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire({
          title: data.payload.Message,
          // text: data.payload.Msg,
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
      }
      dispatch(
        fetchListview(
          "TR368",
          screenName,
          `CompanyID='${CompId}' AND StandardID='${values.StandardID || 0}'`,
          "",
          CompId,
          "003",
        ),
      );
    }
  };
  return (
    <Fragment>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        {/* EDIT ICON */}
        {accessID === "TR289" && (
          <Tooltip
            title={
              ["Pdf", "Ppt"].includes(params.row.ContentType)
                ? "Download"
                : "Open Link"
            }
          >
            <IconButton
              color="info"
              size="small"
              onClick={async () => {
                if (["Pdf", "Ppt"].includes(params.row.ContentType)) {
                  const url = `${
                    store.getState().globalurl.baseUrl1
                  }uploads/attachments/${params.row.AttachmentName}`;

                  try {
                    const response = await fetch(url);
                    const blob = await response.blob();

                    // Create temporary URL
                    const blobUrl = window.URL.createObjectURL(blob);

                    // Create link and click
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = params.row.AttachmentName; // 👈 your filename
                    document.body.appendChild(link);
                    link.click();

                    // Cleanup
                    link.remove();
                    window.URL.revokeObjectURL(blobUrl);
                  } catch (err) {
                    console.error("Download failed", err);
                  }
                } else {
                  // handle other action

                  window.open(params.row.Name, "_blank", "noopener,noreferrer");
                }
              }}
            >
              {["Pdf", "Ppt"].includes(params.row.ContentType) ? (
                <Download />
              ) : (
                <OpenInNewIcon />
              )}
            </IconButton>
          </Tooltip>
        )}

        {/* ASSESSMENT SCREEN */}
        {accessID === "TR290" && (
          <React.Fragment>
            <Tooltip title="Story Board">
              <IconButton
                color="primary"
                size="small"
                // onClick={() =>
                //   navigate(
                //     `/Apps/Secondarylistview/skillglow/TR284/List Of Story Board/${params.row.EmployeeID}/${params.row.AssessmentID}`,
                //     {
                //       ...state,state: { BreadCrumb2: params.row.AssessmentName },
                //     }
                //   )
                // }
                onClick={() =>
                  navigate(
                    `./List Of Story Board/TR284/${params.row.EmployeeID}/${params.row.AssessmentID}`,
                    {
                      state: {
                        ...state,
                        BreadCrumb2: params.row.AssessmentName,
                      },
                    },
                  )
                }
              >
                <FileUploadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Session">
              <IconButton
                color="primary"
                size="small"
                // onClick={() => FnSessionCheck(params.row) }
                onClick={() => {
                  dispatch(
                    SessionCheck({
                      data: {
                        AssessmentID: params.row.AssessmentID,
                        EmployeeID: EMPID,
                      },
                    }),
                  );
                  navigate(
                    `./TR289/List Of Session/${params.row.AssessmentID}`,
                    {
                      state: {
                        ...state,
                        BreadCrumb2: params.row.AssessmentName,
                      },
                    },
                  );
                }}
              >
                <AccessTimeIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={
                params.row.Status === "Pass"
                  ? "View Scoreboard"
                  : "Start Assessment"
              }
            >
              {params.row.Status === "Pass" ? (
                <IconButton
                  color="secondary"
                  size="small"
                  onClick={() =>
                    navigate(
                      "/Apps/skillglow/listpage/SkillGlow/SkillResultDashboard",
                      {
                        state: {
                          ...state,
                          AssessmentName: params.row.AssessmentName,
                          AssessmentID: params.row.AssessmentID,
                          ScheduleID: params.row.RecordID,
                          Lastattdate: params.row.Lastattdate,
                          Firstattdate: params.row.Firstattdate,
                          Lastattscore: params.row.Lastattscore,
                          NoofAttemp: params.row.NoofAttemp,
                          EmployeeName: params.row.EmpName,
                        },
                      },
                    )
                  }
                >
                  <AnalyticsIcon />
                </IconButton>
              ) : (
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => FnAssessmentCheck(params.row)}
                >
                  <QuizIcon />
                </IconButton>
              )}
            </Tooltip>

            {/* HIDE AND SHOW OF ICONS IN ASSESSMENT */}
            {/* 4️ Appraisal Dashboard */}
            {/* <Tooltip
              title={
                params.row.Status === "Pass"
                  ? "View Appraisal Scoreboard"
                  : "In Progress"
              }
            > */}

            {params.row.Status === "Pass" &&
            params.row.AssessmentType === "Appraisal" &&
            params.row.AppraisalType === "Self" ? (
              params.row.AppraisalStatus === "Completed" ? (
                <Tooltip title="View Appraisal Scoreboard">
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() =>
                      navigate(
                        "/Apps/skillglow/listpage/SkillGlow/AppraisalDashboard",
                        {
                          state: {
                            AssessmentName: params.row.AssessmentName,
                            AssessmentID: params.row.AssessmentID,
                            ScheduleID: params.row.RecordID,
                            Lastattdate: params.row.Lastattdate,
                            Firstattdate: params.row.Firstattdate,
                            Lastattscore: params.row.Lastattscore,
                            NoofAttemp: params.row.NoofAttemp,
                            EmployeeName: params.row.EmpName,
                            AppraisalID: params.row.AppraisalID,
                          },
                        },
                      )
                    }
                  >
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="In Progress">
                  <IconButton
                    color="error"
                    size="small"
                    //disabled
                    onClick={() => InprogressCheck()}
                  >
                    <CachedOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              // Fallback when condition is false
              <span />
            )}

            {/* </Tooltip> */}

            {/* <Tooltip title="Start Assessment">
              <IconButton
                color="error"
                size="small"
                 onClick={() =>FnAssessmentCheck(params.row)}
              >
                <AssessmentIcon />
              </IconButton>
            </Tooltip> */}

            {/* <Tooltip title="Verify Assessment">
    <IconButton
      color="secondary"
      size="small"
      onClick={() =>
        navigate(
          `./Edit${screenName}/VerifyAssessment/${params.row.AssessmentID}/${params.row.RecordID}`,
          {
            state: {
              ...state,
              BreadCrumb1,
              BreadCrumb2: params.row.AssessmentName,
              BreadCrumb3: params.row.QuestionGroupName,
              BreadCrumb4: params.row.EmpName,
            },
          }
        )
      }
    >
      <VerifiedOutlinedIcon />
    </IconButton>
  </Tooltip> */}
          </React.Fragment>
        )}
        {/* APPRAISAL SCREEN */}
        {accessID === "TR307" && (
          <React.Fragment>
            <Tooltip title="Story Board">
              <IconButton
                color="primary"
                size="small"
                onClick={() =>
                  navigate(
                    `./List Of Story Board/TR284/${params.row.EmployeeID}/${params.row.AssessmentID}`,
                    {
                      state: {
                        ...state,
                        BreadCrumb2: params.row.AssessmentName,
                      },
                    },
                  )
                }
              >
                <FileUploadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Session">
              <IconButton
                color="primary"
                size="small"
                // onClick={() => FnSessionCheck(params.row) }
                onClick={() => {
                  dispatch(
                    SessionCheck({
                      data: {
                        AssessmentID: params.row.AssessmentID,
                        EmployeeID: EMPID,
                      },
                    }),
                  );
                  navigate(
                    `./TR289/List Of Session/${params.row.AssessmentID}`,
                    {
                      state: {
                        ...state,
                        BreadCrumb2: params.row.AssessmentName,
                      },
                    },
                  );
                }}
              >
                <AccessTimeIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={
                params.row.CurrentAttempt > "0"
                  ? "View Scoreboard"
                  : "Start Appraisal"
              }
            >
              {params.row.CurrentAttempt > "0" ? (
                <IconButton
                  color="secondary"
                  size="small"
                  onClick={() =>
                    navigate(
                      "/Apps/skillglow/listpage/SkillGlow/AppraisalScoreBoard",
                      {
                        state: {
                          ...state,
                          AssessmentName: params.row.AssessmentName,
                          AssessmentID: params.row.AssessmentID,
                          ScheduleID: params.row.RecordID,

                          Lastattdate: params.row.Lastattdate,
                          Firstattdate: params.row.Firstattdate,
                          Lastattscore: params.row.Lastattscore,
                          NoofAttemp: params.row.NoofAttemp,
                          EmployeeName: params.row.EmpName,
                        },
                      },
                    )
                  }
                >
                  <AnalyticsIcon />
                </IconButton>
              ) : (
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => FnAssessmentCheck(params.row)}
                >
                  <QuizIcon />
                </IconButton>
              )}
            </Tooltip>

            {/* {params.row.Status === "Pass" &&
            params.row.AssessmentType === "Appraisal" &&
            params.row.AppraisalType === "Self" ? (
              params.row.AppraisalStatus === "Completed" ? (
                <Tooltip title="View Appraisal Scoreboard">
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() =>
                      navigate(
                        "/Apps/skillglow/listpage/SkillGlow/AppraisalDashboard",
                        {
                          state: {
                            AssessmentName: params.row.AssessmentName,
                            AssessmentID: params.row.AssessmentID,
                            Lastattdate: params.row.Lastattdate,
                            Firstattdate: params.row.Firstattdate,
                            Lastattscore: params.row.Lastattscore,
                            NoofAttemp: params.row.NoofAttemp,
                            EmployeeName: params.row.EmpName,
                            AppraisalID: params.row.AppraisalID,
                          },
                        }
                      )
                    }
                  >
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="In Progress">
                  <IconButton
                    color="error"
                    size="small"
                    //disabled
                    onClick={() => InprogressCheck()}
                  >
                    <CachedOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              // Fallback when condition is false
              <span />
            )} */}
          </React.Fragment>
        )}

        {/* ASSESSMENT TYPE */}
        {accessID === "TR308" &&
          (params.row.Code !== "AP" ? (
            <>
              <Tooltip title="Assessment">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() =>
                    navigate(
                      `/Apps/Secondarylistview/skillglow/TR290/List Of Assessment/${params.row.Code}`,
                      {
                        state: { BreadCrumb1: params.row.Name },
                      },
                    )
                  }
                >
                  <Psychology />
                </IconButton>
              </Tooltip>
              {ManagerEmpIDCS && EMP_TRAINBY === "Y" && (
                <Tooltip title="Evaluation">
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() =>
                      navigate(
                        `/Apps/Secondarylistview/skillglow/TR352/List Of Evaluation/${params.row.Code}`,
                        {
                          state: { BreadCrumb1: params.row.Name },
                        },
                      )
                    }
                  >
                    <RateReviewOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )}
            </>
          ) : (
            <Tooltip title="Appraisal">
              <IconButton
                color="primary"
                size="small"
                onClick={() =>
                  navigate(
                    `/Apps/Secondarylistview/skillglow/TR307/List Of Assessment/${params.row.Code}`,
                    {
                      state: { BreadCrumb1: params.row.Name },
                    },
                  )
                }
              >
                <Psychology />
              </IconButton>
            </Tooltip>
          ))}
        {/* VIEW FOR SHOWCASE*/}
        {accessID === "TR284" && (
          <Tooltip
            title={
              ["Pdf", "Ppt"].includes(params.row.Doctype) ? "Download" : "Open"
            }
          >
            <IconButton
              color="info"
              size="small"
              onClick={async () => {
                if (["Pdf", "Ppt"].includes(params.row.Doctype)) {
                  const url = `${
                    store.getState().globalurl.baseUrl
                  }uploads/attachments/${params.row.Attachmentname}`;

                  try {
                    const response = await fetch(url);
                    const blob = await response.blob();

                    // Create temporary URL
                    const blobUrl = window.URL.createObjectURL(blob);

                    // Create link and click
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = params.row.Attachmentname; // 👈 your filename
                    document.body.appendChild(link);
                    link.click();

                    // Cleanup
                    link.remove();
                    window.URL.revokeObjectURL(blobUrl);
                  } catch (err) {
                    console.error("Download failed", err);
                  }
                } else {
                  // handle other action

                  window.open(params.row.Name, "_blank", "noopener,noreferrer");
                }
              }}
            >
              {["Pdf", "Ppt"].includes(params.row.Doctype) ? (
                <Download />
              ) : (
                <OpenInNewIcon />
              )}
            </IconButton>
          </Tooltip>
        )}

        {/* DELETE */}
        {accessID === "TR279" && (
          <Tooltip title="Delete">
            <IconButton
              color="error"
              size="small"
              onClick={() =>
                navigate(`./Edit${screenName}/${params.row.RecordID}/D`, {
                  state: { ...state },
                })
              }
            >
              <Delete />
            </IconButton>
          </Tooltip>
        )}
        {accessID === "TR368" && (
          <>
            {/* {params.row.IsProcess === "N" ? (
              <Tooltip title="Edit">
                <IconButton
                  color="info"
                  size="small"
                  onClick={() =>
                    navigate(`./Edit${screenName}/${params.row.RecordID}/E`, {
                      state: {
                        ...state,
                        MilestoneID: params.row.Section,
                        MilestoneName: params.row.MilestoneDesc,
                        projectID: params.row.StandardID,
                        projectName: params.row.ProjectDesc,
                        BreadCrumb2: params.row.Term,
                        BreadCrumb3: params.row.Description,
                      },
                    })
                  }
                >
                  <ModeEditOutlinedIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="View">
                <IconButton
                  color="info"
                  size="small"
                  onClick={() =>
                    navigate(`./Edit${screenName}/${params.row.RecordID}/V`, {
                      state: {
                        ...state,
                        MilestoneID: params.row.Section,
                        MilestoneName: params.row.MilestoneDesc,
                        projectID: params.row.StandardID,
                        projectName: params.row.ProjectDesc,
                        BreadCrumb2: params.row.Term,
                        BreadCrumb3: params.row.Description,
                      },
                    })
                  }
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>)} */}

            <Tooltip title="Timetable">
              <IconButton
                color="info"
                size="small"
                onClick={() =>
                  navigate(`./ProjectTimeTable`, {
                    state: {
                      ...state,
                      MilestoneID: params.row.Section,
                      MilestoneName: params.row.MilestoneDesc,
                      TermsID: params.row.TermID,
                      projectID: params.row.StandardID,
                      projectName: params.row.ProjectDesc,
                      Description: params.row.Description,
                      TermName: params.row.TermName,
                      GroupID: params.row.SlotGroupID,
                      HeaderID: params.row.RecordID,
                    },
                  })
                }
              >
                <CalendarMonthOutlinedIcon />
              </IconButton>
            </Tooltip>

            {/* {params.row.IsProcess === "N" ? (
              <Tooltip title="Process">
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => handleTermsProcess(params.row)}
                >
                  <LockResetOutlinedIcon />
                </IconButton>
              </Tooltip>) : (
              <Tooltip title="Process">
                <IconButton
                  color="error"
                  size="small"
                  sx={{
                    opacity: 0.5
                  }}
                // onClick={() =>handleTermsProcess(params.row)}
                >
                  <LockResetOutlinedIcon />
                </IconButton>
              </Tooltip>)} */}
          </>
        )}
        {/* {accessID === "TR342" && params.row.Status === "Appeared" && ( */}
        {accessID === "TR352" && params.row.Status === "Appeared" && (
          <Tooltip title="Verify Assessment">
            <IconButton
              color="secondary"
              size="small"
              onClick={() =>
                navigate(
                  `./Edit${screenName}/VerifyAssessment/${params.row.AssessmentID}/${params.row.RecordID}/${params.row.EmployeeID}`,
                  {
                    state: {
                      ...state,
                      BreadCrumb1,
                      BreadCrumb2: params.row.AssessmentName,
                      BreadCrumb3: params.row.QuestionGroupName,
                      BreadCrumb4: params.row.EmpName,
                    },
                  },
                )
              }
            >
              <VerifiedOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}

        {/* {accessID === "TR342" && params.row.Status === "Pass" && ( */}
        {accessID === "TR352" && params.row.Status === "Pass" && (
          <Tooltip title="View Scoreboard">
            <IconButton
              color="secondary"
              size="small"
              onClick={() =>
                navigate("/Apps/skillglow/listpage/SkillGlow/EmpDashBoard", {
                  state: {
                    ...state,
                    AssessmentName: params.row.AssessmentName,
                    AssessmentID: params.row.AssessmentID,
                    ScheduleID: params.row.RecordID,
                    Lastattdate: params.row.Lastattdate,
                    Firstattdate: params.row.Firstattdate,
                    Lastattscore: params.row.Lastattscore,
                    NoofAttemp: params.row.NoofAttemp,
                    EmployeeName: params.row.EmpName,
                    EmployeeID: params.row.EmployeeID,
                  },
                })
              }
            >
              <AnalyticsIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Fragment>
  );
};

const RoutineTaskAction = ({ params, accessID, screenName, rights }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const dispatch = useDispatch();
  const EMPID = sessionStorage.getItem("EmpId");
  const { BreadCrumb1 } = location.state || {};

  return (
    <Fragment>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        {/* EDIT ICON */}
        {accessID === "TR270" && (
          <Tooltip title="Edit">
            <IconButton
              color="info"
              size="small"
              onClick={() =>
                navigate(`./Edit${screenName}/${params.row.RecordID}/E`, {
                  state: { ...state },
                })
              }
            >
              <ModeEditOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Fragment>
  );
};
// export const leaveAppoval = createAsyncThunk(
//   "leave/approval",
//   async ({ data},{rejectWithValue}) => {
//     var url = store.getState().globalurl.leavelApprovalUrl;
//     console.log("get" + JSON.stringify(data));
//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization:
//           "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//       },
//     });
//     console.log(
//       "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
//       response
//     );
//     return response.data;
//   }
// );

export const leaveAppoval = createAsyncThunk(
  "leave/approval",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.leavelApprovalUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const SessionCheck = createAsyncThunk(
  "leave/SessionCheck",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.SessionCheckUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const AssessmentCheck = createAsyncThunk(
  "Skillglow/AssessmentCheck",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.AssessmentCheckUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);
